import React, { useEffect, useRef, useState } from "react";
import { Field, FormikProvider, Form, useFormik, ErrorMessage } from "formik";
import * as DESUI from "react-bootstrap";
import Menubar from "../Menubar";
import { store } from "../../App";
import * as Yup from "yup";
import { MdCampaign, MdEmail, MdOutlineDrafts, MdOutlineIntegrationInstructions, MdOutlinePictureAsPdf, MdOutlineRecommend, MdOutlineVerified, MdPhone } from "react-icons/md";
import Select from "react-select";
import { Row, Col, Container, Button, Modal } from "react-bootstrap";
import useAlert from "../Alert/useAlert";
import AlertModal from "../Alert/AlertModal";
import HeaderPage from "../HeaderPage";
import { FaAward, FaCity, FaDownload, FaLayerGroup, FaLeaf, FaLightbulb, FaListUl, FaMicrochip, FaPlus, FaPuzzlePiece, FaRegSave, FaTrash, FaUtensils, FaWater } from "react-icons/fa";
import allowNumbersOnly, { allowAlphabetAndSpacesOnly } from "../utils/commonFunctions";
import KpiService from "../../Services/KpiService";
import Swal from "sweetalert2";
import { FieldArray } from "formik";

import html2pdf from "html2pdf.js";

import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { saveAs } from "file-saver";
import { RiSendPlaneFill } from "react-icons/ri";
import { FiDownload } from "react-icons/fi";
import MasterService from "../../Services/MasterService";
import { LuCircleUser, LuPlus, LuSaveAll } from "react-icons/lu";
import HTMLFlipBook from "react-pageflip";
import { Document as BookDocument, Page, pdfjs } from "react-pdf"
import { GrLinkNext } from "react-icons/gr";
import { IoMdArrowBack } from "react-icons/io";

pdfjs.GlobalWorkerOptions.workerSrc =
  `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.mjs`;



export default function FeedbackForm() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();
  const [distlist, setDistlist] = useState([]);
  const [designationlist, setDesignationlist] = useState([]);
  const [deptlist, setDeptlist] = useState([]);
  const [topics, setTopics] = useState([]);
  const [subtopics, setSubtopics] = useState([]);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [showSendOtp, setShowSendOtp] = useState(false);
  const quillRef = useRef(null);

  const flipBookRef = useRef(null);
  const [selectedManual, setSelectedManual] = useState(null);
  const [numPages, setNumPages] = useState(0);
  const [page, setPage] = useState(1);
  const desktopFlipBookRef = useRef(null);
  const tabletFlipBookRef = useRef(null);
  const mobileFlipBookRef = useRef(null);
  const [otpMessage, setOtpMessage] = useState("");
  const [otpTimer, setOtpTimer] = useState(0);
  const [showSubmitConfirmModal, setShowSubmitConfirmModal] = useState(false);
const [pendingSubmitMode, setPendingSubmitMode] = useState(null);
const [pendingSubmitAction, setPendingSubmitAction] = useState(null);


  useEffect(() => {
    if (otpTimer <= 0) return;

    const timer = setInterval(() => {
      setOtpTimer((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [otpTimer]);


  const handlePaste = async (e) => {
    const clipboardData = e.clipboardData || window.clipboardData;
    if (!clipboardData) return;
    const items = clipboardData.items;
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item.type.indexOf("image") !== -1) {
        e.preventDefault();

        const file = item.getAsFile();

        if (!file) return;

        const reader = new FileReader();

        reader.onload = (event) => {
          const imageUrl = event.target.result;

          const quill = quillRef.current?.getEditor();

          if (!quill) return;

          const range = quill.getSelection(true);

          quill.insertEmbed(
            range.index,
            "image",
            imageUrl,
            "user"
          );

          quill.setSelection(
            range.index + 1,
            0,
            "user"
          );
        };

        reader.readAsDataURL(file);
      }
    }
  };

  useEffect(() => {
    MasterService.getFeedbackdistrictmst().then((districtRes) => {
      if (districtRes.data) {
        setDistlist(districtRes.data)
      }
    }).catch((error) => { showAlertMessage("Error fetching details. Please try again.", "warning"); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });

    MasterService.snccsFeedbackdesignation().then((designationRes) => {
      if (designationRes.data) {
        setDesignationlist(designationRes.data)
      }
    }).catch((error) => { showAlertMessage("Error fetching details. Please try again.", "warning"); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });



    MasterService.getFeedbacksecretariatmst().then((deptRes) => {
      if (deptRes.data) {
        setDeptlist(deptRes.data.SDESC);
      }
    }).catch((error) => { showAlertMessage("Error fetching details. Please try again.", "warning"); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
    KpiService.snccsTopics()
      .then((res) => {
        if (Array.isArray(res?.data)) {
          setTopics(res.data);
        } else {
          setTopics([]);
        }
      })



  }, []);

  const [currentStep, setCurrentStep] = useState(1);
  const [submitMode, setSubmitMode] = useState("save");


  const STEP_LABELS = [{ label: "INSTRUCTIONS", icon: <MdOutlineIntegrationInstructions className="me-1" style={{ color: "black" }} size={20} /> }, { label: "OFFICER DETAILS", icon: <LuCircleUser className="me-1 mb-1" style={{ color: "black" }} size={20} /> }, { label: "FEEDBACK", icon: <MdOutlineVerified className="me-1 mb-1" style={{ color: "black" }} size={20} /> },];

 

  const manuals = [
    ["5 Specific Priority Objectives for Viksit Bharat@2047", "/Theme1.pdf"],
    ["Mining for Economic Growth and Stronger State Finances", "/Theme2.pdf"],
    ["Technology in Governance", "/Theme3.pdf"],
    ["Accelerating Linear Infrastructure Projects: Good Practices & New Ideas", "/Theme4.pdf"],
  ];

  const previousPage = () => { if (window.innerWidth <= 576) { mobileFlipBookRef.current?.pageFlip().flipPrev(); } else if (window.innerWidth <= 992) { tabletFlipBookRef.current?.pageFlip().flipPrev(); } else { desktopFlipBookRef.current?.pageFlip().flipPrev(); } };

  const nextPage = () => { if (window.innerWidth <= 576) { mobileFlipBookRef.current?.pageFlip().flipNext(); } else if (window.innerWidth <= 992) { tabletFlipBookRef.current?.pageFlip().flipNext(); } else { desktopFlipBookRef.current?.pageFlip().flipNext(); } };


  // OTP modal / verified state lights up step 3
  const activeStepIndex = otpVerified || showOtpModal ? 3 : currentStep;
  const [isCurrentTopicSubmitted, setIsCurrentTopicSubmitted] = useState(false);

  const [isSubmitted, setIsSubmitted] = useState(false);

  const SUBTOPIC_IDS = ["11", "12", "13", "14", "15"];

  const SUB_FIELD_PREFIXES = [
    "pgapsandChallengesSub",
    "potentialSolSub",
    "bestPracticesSub",
    "otherSuggestionsSub",
  ];

  // 11 -> "" (no suffix), others -> their id
  const getSubSuffix = (id) => (String(id) === "11" ? "" : String(id));

  const buildSubtopicInitialValues = () => {
    const values = {};

    SUBTOPIC_IDS.forEach((id) => {
      SUB_FIELD_PREFIXES.forEach((prefix) => {
        values[`${prefix}${getSubSuffix(id)}`] = "";
      });
    });

    return values;
  };
  const formik = useFormik({
    initialValues: {
      cfms_id: "",
      name: "",
      designation: "",
      batch: "",
      current_service_status: "",
      training_institute: "",
      current_posting: "",
      topic_name: "",
      sub_topic_name: "",
      policy_gaps_challenges: "",
      potential_solutions: "",
      best_practices: "",
      cfms_mob: "",
      selectedTopic: "",
      otp_mobile: "",
      dept_id: "",
      district_id: "",
      levelOfEntry: "",
      suggestedActionMatrix: [
        {
          issue: "",
          proposed_action: "",
          lead_agency: "",
          supporting_agencies: "",
          expected_output_timeline: "",
        },
      ],

      ...buildSubtopicInitialValues(),
    },

    validationSchema: Yup.object({
      cfms_id: Yup.string().required("CFMS ID is required"),
      name: Yup.string().required("Name is required"),

      designation: Yup.string().required("Designation is required"),
      entry_level: Yup.string().required("Entry level is required"),
      // batch: Yup.string().required("Batch is required"),
      district_id: Yup.string().when("entry_level", {
        is: (value) => value !== "1" && value !== "2",
        then: (schema) => schema.required("District ID is required"),
        otherwise: (schema) => schema.notRequired(),
      }), dept_id: Yup.string().required("Department ID is required"),
      // current_service_status: Yup.string().required("Current Service Status is required"),
      training_institute: Yup.string().when("current_service_status", { is: "1", then: (schema) => schema.required("Training Institute / Academy is required"), otherwise: (schema) => schema.notRequired(), }),
      current_posting: Yup.string().when("current_service_status", { is: "2", then: (schema) => schema.required("Current Posting is required"), otherwise: (schema) => schema.notRequired(), }),

      //   topic_name: Yup.string() .required("Name of the topic is required") .test( "not-empty", "Name of the topic is required", (value) => value?.replace(/•/g, "").trim().length > 0 ),
      //   policy_gaps_challenges: Yup.string() .required("Policy gaps and challenges are required") .min(10, "Please provide at least 10 characters"),

      //   potential_solutions: Yup.string() .required("Potential solutions are required") .min(10, "Please provide at least 10 characters"),
      //    best_practices: Yup.string() .required("Best practices are required") .min(10, "Please provide at least 10 characters"),


    }),

  
    onSubmit: (values) => {
const cleanRichText = (value) => {
  if (!value) return "";

  const temp = document.createElement("div");
  temp.innerHTML = String(value);

  const text = (temp.textContent || temp.innerText || "")
    .replace(/\u00a0/g, " ")
    .trim();

  return text ? String(value) : "";
};

const isRichTextEmpty = (value) => {
  if (!value) return true;

  const temp = document.createElement("div");
  temp.innerHTML = String(value);

  return !(temp.textContent || temp.innerText || "")
    .replace(/\u00a0/g, " ")
    .trim();
};


  const validateSuggestedActionMatrix = () => {
  const rows = formik.values.suggestedActionMatrix || [];

  const issues = rows
    .map((row) => (row.issue || "").trim().toLowerCase())
    .filter((issue) => issue !== "");

  const duplicateIssues = issues.filter(
    (issue, index) => issues.indexOf(issue) !== index
  );

  if (duplicateIssues.length > 0) {
    showAlertMessage(
      "Duplicate Issue found. Please enter a different Issue for each row.",
      "warning"
    );
    return false;
  }

  return true;
};

  if (String(values.topic_name) === "2") {
    if (!validateSuggestedActionMatrix()) {
      return;
    }
  }
      const params = {
        mode: submitMode,
        cfmsId: values.cfms_id,
        fname: values.name,
        lname: "",
        dob: "",
        gender: "",
        mobile: mobileNumber || formik.values.otp_mobile,
        email: "",
        levelOfEntry: values.entry_level,
        designation: values.designation,
        batchYear: values.batch || "0",
        deptId: values.dept_id,
        districtId: values.district_id || "0",

        currentServiceStatus:
          values.current_service_status === "1"
            ? "Probationer"
            : values.current_service_status === "2"
              ? "Confirmed"
              : "0",

        trainingInstitute:
          values.current_service_status === "1"
            ? values.training_institute
            : "",

        currentPosting:
          values.current_service_status === "2"
            ? values.current_posting
            : "",

        nameOfTopic: values.topic_name || "",
        nameOfSubTopic: values.sub_topic_name || "",

    pgapsAndChallenges: cleanRichText(values.policy_gaps_challenges),
potentialSol: cleanRichText(values.potential_solutions),
bestPractices: cleanRichText(values.best_practices),
otherSuggestions: cleanRichText(values.other_suggestions),

        // Topic 2 only
        ...(String(values.topic_name) === "2" && {
          swaSnccsFeedbackFormSuggestedActionMatrixDto:
            (values.suggestedActionMatrix || []).map((row) => ({
              issue: row.issue || "",
              proposedAction: row.proposed_action || "",
              leadAgency: row.lead_agency || "",
              supportingAgencies: row.supporting_agencies || "",
              expectedOutcomeTimeline:
                row.expected_output_timeline || "",
            })),
        }),
      };
   if (String(values.topic_name) === "1") {
  params.pgapsAndChallenges = "";
  params.potentialSol = "";
  params.bestPractices = "";
  params.otherSuggestions = "";

  SUBTOPIC_IDS.forEach((id) => {
    if (id === "11") {
      params.pgapsAndChallenges = cleanRichText( values.pgapsandChallengesSub );
params.potentialSol = cleanRichText( values.potentialSolSub );

      params.bestPractices = cleanRichText( values.bestPracticesSub );

      params.otherSuggestions = cleanRichText( values.otherSuggestionsSub );
    } else {
      params[`pgapsandChallengesSub${id}`] = cleanRichText( values[`pgapsandChallengesSub${id}`] );

      params[`potentialSolSub${id}`] = cleanRichText( values[`potentialSolSub${id}`] );

      params[`bestPracticesSub${id}`] = cleanRichText( values[`bestPracticesSub${id}`] );

      params[`otherSuggestionsSub${id}`] = cleanRichText( values[`otherSuggestionsSub${id}`] );
    }
  });
}
      console.log("Loading draft for topic:", formik.values);

      console.log("API Params:", params);
      const isTopic1 = String(values.topic_name) === "1";


     if (submitMode === "submit" && isTopic1) {

  const checkedIds = parseSubIds(selectedTopics).map(String);

  // At least one subtopic must be selected
  if (checkedIds.length === 0) {
    showAlertMessage(
      "Please select at least one subtopic before submitting.",
      "warning"
    );
    return;
  }

  // Validate mandatory fields only for selected subtopics
  for (const id of checkedIds) {

    const policyGaps =
      id === "11"
        ? values.pgapsandChallengesSub
        : values[`pgapsandChallengesSub${id}`];

    const potentialSolutions =
      id === "11"
        ? values.potentialSolSub
        : values[`potentialSolSub${id}`];

    const bestPractices =
      id === "11"
        ? values.bestPracticesSub
        : values[`bestPracticesSub${id}`];

    const subtopicName =
      subtopics?.find((s) => String(s.id) === id)?.value ||
      `Sub topic ${id}`;

    // Policy Gaps & Challenges
    if (isRichTextEmpty(policyGaps)) {
      showAlertMessage(
        `Please enter Policy Gaps & Challenges for "${subtopicName}" before submitting.`,
        "warning"
      );
      return;
    }

    // Potential Solutions
    if (isRichTextEmpty(potentialSolutions)) {
      showAlertMessage(
        `Please enter Potential Solutions for "${subtopicName}" before submitting.`,
        "warning"
      );
      return;
    }

    // Best Practices
    if (isRichTextEmpty(bestPractices)) {
      showAlertMessage(
        `Please enter Best Practices for "${subtopicName}" before submitting.`,
        "warning"
      );
      return;
    }

    // Other Suggestions is NOT mandatory
  }
}


 if (submitMode === "submit" && !isTopic1) {
  const topicId = String(values.topic_name);

  if (["2", "3", "4"].includes(topicId)) {

    if (isRichTextEmpty(values.policy_gaps_challenges)) {
      showAlertMessage(
        "Please fill Policy Gaps & Challenges before submitting.",
        "warning"
      );
      return;
    }

    if (isRichTextEmpty(values.potential_solutions)) {
      showAlertMessage(
        "Please fill Potential Solutions before submitting.",
        "warning"
      );
      return;
    }

    if (isRichTextEmpty(values.best_practices)) {
      showAlertMessage(
        "Please fill Best Practices before submitting.",
        "warning"
      );
      return;
    }
  }
}
      const submitFeedback = () => {
        store.dispatch({ type: "SHOW_SPINNER" });
        KpiService.feedbackForm(params)
          .then(async (res) => {

            if (res.data?.SCODE === "01") {
              setSavedPayload(params);
              setIsSaved(true);

              if (submitMode === "submit") {
                const submittedTopicId = formik.values.topic_name;

                setExistingTopics((prev) => [
                  ...prev,
                  {
                    name_of_topic: submittedTopicId,
                    is_finalsubmit: true,
                  },
                ]);

                setIsCurrentTopicSubmitted(true);
                setSaveafterDisable(false);
                setFirstentry(true);
                setStep2Completed(true);
                setSelectingNewTopic(true);

                clearAllSubtopicFields();

                formik.setFieldValue("topic_name", "");
                formik.setFieldValue("sub_topic_name", "");
                formik.setFieldValue("policy_gaps_challenges", "");
                formik.setFieldValue("potential_solutions", "");
                formik.setFieldValue("best_practices", "");
                formik.setFieldValue("other_suggestions", "");

                setSubtopics([]);
              }

              if (submitMode === "save") {
                setSaveafterDisable(false);
                setSelectingNewTopic(true);
                setStep2Completed(true);
              }

              showAlertMessage(res.data.SDESC, "success");

              setOtp("");
              setOtpSent(false);
              setOtpVerified(false);
              setShowOtpModal(false);

              refreshExistingTopics(values.cfms_id);
            } else {
              showAlertMessage(
                res.data?.SDESC || "Unable to save feedback",
                "warning"
              );
            }
          })
          .catch((error) => {
            store.dispatch({ type: "HIDE_SPINNER" }); 
            console.error("Feedback submission error:", error);

            showAlertMessage(
              "Something went wrong while submitting the feedback.",
              "error"
            );
          })
          .finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
      };





    if (submitMode === "submit" && isTopic1) {
  setPendingSubmitMode(submitMode);

  // Store the current submit function
  setPendingSubmitAction(() => submitFeedback);

  setShowSubmitConfirmModal(true);
  return;
}


   
      submitFeedback();

  
  
    },
  });



  const batchYears = Array.from(
    { length: new Date().getFullYear() - 1985 },
    (_, index) => new Date().getFullYear() - 1 - index
  );

  const batchOptions = batchYears.map((year) => ({
    id: String(year),
    value: String(year),
  }));

  const [isSaved, setIsSaved] = useState(false);
  const [savedPayload, setSavedPayload] = useState(null);

  const generatePdfDocument = async (data) => {

    let container = null;

    try {

      console.log("PDF DATA:", data);

     const {
  cfmsId,
  fname,
  designation,
  batchYear,
  currentServiceStatus,
  trainingInstitute,
  currentPosting,
  nameOfTopic,
  subTopicNames,
  topic1Feedback,
  pgapsAndChallenges,
  potentialSol,
  bestPractices,
  otherSuggestions,
  suggestedActionMatrix,
} = data || {};
      // =========================================================
      // HELPERS
      // =========================================================

      const safeText = (value) => {

        if (value === null || value === undefined) {
          return "";
        }

        return String(value);
      };

      const escapeHtml = (value) => {

        return safeText(value)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&#039;");
      };

      const safeCfmsId = safeText(cfmsId)
        .replace(/[^a-zA-Z0-9_-]/g, "")
        .trim();

      // =========================================================
      // RICH TEXT SANITIZATION
      // =========================================================

      const sanitizeRichText = (value) => {

        if (!value) {
          return "";
        }

        try {

          const parser = new DOMParser();

          const doc = parser.parseFromString(
            `<div>${safeText(value)}</div>`,
            "text/html"
          );

          const root = doc.body.firstElementChild;

          if (!root) {
            return escapeHtml(value).replace(/\n/g, "<br>");
          }

          root
            .querySelectorAll(
              "script, style, iframe, object, embed, link, meta, noscript"
            )
            .forEach((el) => el.remove());

          // =====================================================
          // ADDED IMG
          // =====================================================

          const allowedTags = new Set([
            "P",
            "BR",
            "STRONG",
            "B",
            "EM",
            "I",
            "U",
            "UL",
            "OL",
            "LI",
            "TABLE",
            "THEAD",
            "TBODY",
            "TFOOT",
            "TR",
            "TH",
            "TD",
            "DIV",
            "SPAN",
            "IMG",
          ]);

          const cleanNode = (node) => {

            // ===================================================
            // TEXT
            // ===================================================

            if (node.nodeType === Node.TEXT_NODE) {
              return escapeHtml(node.textContent);
            }

            if (node.nodeType !== Node.ELEMENT_NODE) {
              return "";
            }

            const tag = node.tagName.toUpperCase();

            // ===================================================
            // UNSUPPORTED TAG
            // ===================================================

            if (!allowedTags.has(tag)) {

              return Array.from(node.childNodes)
                .map(cleanNode)
                .join("");
            }

            // ===================================================
            // IMAGE
            // ===================================================

            if (tag === "IMG") {

              const src = node.getAttribute("src");

              // Your backend sends:
              // data:image/png;base64,...

              if (
                !src ||
                !src.startsWith("data:image/")
              ) {
                return "";
              }

              return `
  <img
    src="${src}"
    style="
      width: 180px;
      max-width: 180px;
      height: auto;
      display: block;
      margin: 6pt 0;
    "
    alt=""
  />
`;
            }

            if (tag === "BR") {
              return "<br>";
            }

            if (tag === "TABLE") {

              return `
              <table>
                ${Array.from(node.childNodes)
                  .map(cleanNode)
                  .join("")}
              </table>
            `;
            }

            // ===================================================
            // TABLE CELLS
            // ===================================================

            if (tag === "TH" || tag === "TD") {

              return `
              <${tag.toLowerCase()}>
                ${Array.from(node.childNodes)
                  .map(cleanNode)
                  .join("")}
              </${tag.toLowerCase()}>
            `;
            }

            // ===================================================
            // NORMAL ELEMENT
            // ===================================================

            return `
            <${tag.toLowerCase()}>
              ${Array.from(node.childNodes)
                .map(cleanNode)
                .join("")}
            </${tag.toLowerCase()}>
          `;
          };

          return Array.from(root.childNodes)
            .map(cleanNode)
            .join("")
            .trim();

        } catch (error) {

          console.error(
            "Rich text sanitization error:",
            error
          );

          return escapeHtml(value).replace(
            /\n/g,
            "<br>"
          );
        }
      };

      // =========================================================
      // SUB TOPICS
      // =========================================================

      // =========================================================
      // SUB TOPICS
      // =========================================================

      const getSubTopicsHtml = () => {
        if (
          !Array.isArray(subTopicNames) ||
          subTopicNames.length === 0
        ) {
          return "";
        }

        return `
    <div class="sub-topic-section">

      <div class="sub-topic-label">
        Specific Priority Area(s):
      </div>

      <ol class="sub-topic-list">
        ${subTopicNames
            .map(
              (subTopic, index) => `
              <li>
                ${index + 1}.1 ${escapeHtml(subTopic)}
              </li>
            `
            )
            .join("")}
      </ol>

    </div>
  `;
      };
      const getTopic1FeedbackHtml = () => {
        if (!Array.isArray(topic1Feedback) || topic1Feedback.length === 0) {
          return "";
        }

        return `
    <div class="topic1-feedback-wrapper">

      ${topic1Feedback
            .map((sub, index) => {
              const areaNo = index + 1;

              return `
            <div class="topic1-subtopic">

              <div class="topic1-subtopic-title">
                Specific Priority Area ${areaNo}:
              </div>

              <!-- Sub Topic -->
              <div class="topic1-subtopic-name">
                ${escapeHtml(sub.name || `Sub Topic ${areaNo}`)}
              </div>

              <!-- Policy Gaps -->
              <div class="topic1-question">
                <div class="topic1-question-title">
                  ${areaNo}.2 Policy Gaps and Challenges
                </div>

                <div class="rich-content topic1-content">
                  ${getRichContent(
                sub.pgapsAndChallenges || "Not provided"
              )}
                </div>
              </div>

              <!-- Potential Solutions -->
              <div class="topic1-question">
                <div class="topic1-question-title">
                  ${areaNo}.3 Potential Solutions
                </div>

                <div class="rich-content topic1-content">
                  ${getRichContent(
                sub.potentialSol || "Not provided"
              )}
                </div>
              </div>

              <!-- Best Practices -->
              <div class="topic1-question">
                <div class="topic1-question-title">
                  ${areaNo}.4 Best Practices
                </div>

                <div class="rich-content topic1-content">
                  ${getRichContent(
                sub.bestPractices || "Not provided"
              )}
                </div>
              </div>

         ${
  hasActualData(sub.otherSuggestions)
    ? `
      <div class="topic1-question">
        <div class="topic1-question-title">
          ${areaNo}.5 Other Suggestions
        </div>

        <div class="rich-content topic1-content">
          ${getRichContent(sub.otherSuggestions)}
        </div>
      </div>
    `
    : ""
}
            </div>
          `;
            })
            .join("")}

    </div>
  `;
      };

      // =========================================================
      // RICH CONTENT
      // =========================================================

      const getRichContent = (value) => {

        const result = sanitizeRichText(value);

        if (!result) {

          return `
          <p class="empty-content">
            Not provided
          </p>
        `;
        }

        return result;
      };
const cellStyle =
  "border-right:1px solid #000;border-bottom:1px solid #000;padding:6px 8px;vertical-align:top;text-align:left;";
const thStyle =
  "border-right:1px solid #000;border-bottom:1px solid #000;padding:6px 8px;text-align:center;font-weight:700;background:#f3f3f3;";

const hasActualData = (value) => {
  if (value === null || value === undefined) {
    return false;
  }

const cleanHtml = (value) => {
  if (value == null) return "";

  const div = document.createElement("div");
  div.innerHTML = String(value);

  return (div.textContent || div.innerText || "")
    .replace(/&nbsp;/gi, " ")
    .replace(/&#160;/gi, " ")
    .trim();
};
const cleaned = cleanHtml(value);
  return cleaned !== "";
};

const hasMatrixRowData = (row) => {
  if (!row || typeof row !== "object") {
    return false;
  }

  return (
    hasActualData(row.issue) ||
    hasActualData(row.proposed_action) ||
    hasActualData(row.lead_agency) ||
    hasActualData(row.supporting_agencies) ||
    hasActualData(row.expected_output_timeline)
  );
};


const getSuggestedActionMatrixHtml = () => {

  // =========================================================
  // NO MATRIX
  // =========================================================

  if (
    !Array.isArray(suggestedActionMatrix) ||
    suggestedActionMatrix.length === 0
  ) {
    return "";
  }

  // =========================================================
  // REMOVE EMPTY ROWS
  // =========================================================

  const validRows = suggestedActionMatrix.filter(
    (row) => hasMatrixRowData(row)
  );

  // =========================================================
  // ALL ROWS EMPTY
  // =========================================================

  if (validRows.length === 0) {
    return "";
  }

  // =========================================================
  // RENDER ONLY VALID ROWS
  // =========================================================

  return `
    <div class="suggested-action-matrix">

      <div class="question-title">
        5. Suggested Action Matrix
      </div>

      <table
        class="action-matrix-table"
        style="
          width:100%;
          table-layout:fixed;
          border-collapse:separate;
          border-spacing:0;
          border-top:1px solid #000;
          border-left:1px solid #000;
        "
      >

        <thead>
          <tr>
            <th style="${thStyle}">
              Issue
            </th>

            <th style="${thStyle}">
              Proposed Action
            </th>

            <th style="${thStyle}">
              Lead Agency
            </th>

            <th style="${thStyle}">
              Supporting Agencies
            </th>

            <th style="${thStyle}">
              Expected Outcome / Timeline
            </th>
          </tr>
        </thead>

        <tbody>

          ${validRows
            .map(
              (row) => `
                <tr>

                  <td style="${cellStyle}">
                    ${
                      hasActualData(row.issue)
                        ? getRichContent(row.issue)
                        : ""
                    }
                  </td>

                  <td style="${cellStyle}">
                    ${
                      hasActualData(row.proposed_action)
                        ? getRichContent(row.proposed_action)
                        : ""
                    }
                  </td>

                  <td style="${cellStyle}">
                    ${
                      hasActualData(row.lead_agency)
                        ? getRichContent(row.lead_agency)
                        : ""
                    }
                  </td>

                  <td style="${cellStyle}">
                    ${
                      hasActualData(row.supporting_agencies)
                        ? getRichContent(
                            row.supporting_agencies
                          )
                        : ""
                    }
                  </td>

                  <td style="${cellStyle}">
                    ${
                      hasActualData(
                        row.expected_output_timeline
                      )
                        ? getRichContent(
                            row.expected_output_timeline
                          )
                        : ""
                    }
                  </td>

                </tr>
              `
            )
            .join("")}

        </tbody>
      </table>

    </div>
  `;
};
   const hasOtherSuggestions =
  hasActualData(otherSuggestions);
      // =========================================================
      // LOAD LOGO
      // =========================================================

      const getImageAsBase64 = async (imageUrl) => {

        try {

          const response = await fetch(imageUrl);

          if (!response.ok) {

            throw new Error(
              `Failed to load image: ${response.status}`
            );
          }

          const blob = await response.blob();

          return await new Promise(
            (resolve, reject) => {

              const reader = new FileReader();

              reader.onloadend = () => {
                resolve(reader.result);
              };

              reader.onerror = reject;

              reader.readAsDataURL(blob);
            }
          );

        } catch (error) {

          console.error(
            "Logo loading failed:",
            error
          );

          return "";
        }
      };

      const logoBase64 =
        await getImageAsBase64(
          `${window.location.origin}/images/nitiaayog.png`
        );

      console.log(
        "NITI Aayog logo loaded:",
        logoBase64 ? "YES" : "NO"
      );

      // =========================================================
      // STATUS / POSTING
      // =========================================================

      const status = safeText(
        currentServiceStatus
      ).trim();

      const isProbationer =
        status.toLowerCase() === "probationer" ||
        status === "1";

      const postingLabel =
        isProbationer
          ? "Training Institute / Academy"
          : "Current Posting";

      const postingValue =
        isProbationer
          ? trainingInstitute
          : currentPosting;

      // =========================================================
      // PDF HTML
      // =========================================================

      const html = `
 
      <style>
 
        * {
          box-sizing: border-box;
        }
 
        html,
        body {
          margin: 0;
          padding: 0;
          background: #ffffff;
        }
 
        .pdf-document {
 
          width: 794px;
 
          min-height: 1123px;
 
          padding: 15mm;
 
          margin: 0;
 
          background: #ffffff;
 
          color: #111111;
 
          font-family:
            "Times New Roman",
            Times,
            serif;
 
          font-size: 11pt;
 
          line-height: 1.25;
        }
 
        /* =====================================================
           HEADER
           ===================================================== */
 
        .pdf-header {
 
          text-align: center;
 
          margin-bottom: 32px;
 
          padding-top: 4px;
        }
 
        .logo-wrapper {
 
          text-align: center;
 
          height: 100px;
 
          margin-bottom: 18px;
 
          display: flex;
 
          justify-content: center;
 
          align-items: center;
        }
 
        .logo {
 
          width: 82px;
 
          height: 72px;
 
          object-fit: contain;
 
          display: block;
        }
 
        .main-title,
        .sub-title {
 
          font-family:
            "Times New Roman",
            Times,
            serif;
 
          font-size: 14pt;
 
          font-weight: 700;
 
          line-height: 1.25;
 
          text-align: center;
 
          display: block;
 
          color: #000000;
        }
 
        .main-title {
 
          margin: 0;
 
          padding: 0;
 
          color: #000000;
        }
 
        .sub-title {
 
          margin-top: 6pt;
        }
 
        /* =====================================================
           SECTION HEADINGS
           ===================================================== */
 
        .section-title {
 
          font-family:
            "Times New Roman",
            Times,
            serif;
 
          font-size: 12pt;
 
          font-weight: 700;
 
          margin-top: 14pt;
 
          margin-bottom: 6pt;
 
          line-height: 1.25;
        }
 
        /* =====================================================
           OFFICER DETAILS
           ===================================================== */
 
        .officer-details {
 
          margin: 0;
 
          padding-left: 28px;
 
          font-family:
            "Times New Roman",
            Times,
            serif;
 
          font-size: 11pt;
 
          line-height: 1.25;
        }
 
        .officer-details li {
 
          margin-bottom: 3pt;
 
          padding-left: 1px;
        }
 
        .officer-details strong {
 
          font-weight: 700;
        }
 
        /* =====================================================
           FEEDBACK SECTION
           ===================================================== */
 
        .feedback-section {
 
          margin-top: 9pt;
 
          margin-bottom: 0;
 
          padding-bottom: 0;
        }
 
        .question-title {
 
          font-family:
            "Times New Roman",
            Times,
            serif;
 
          font-size: 12pt;
 
          font-weight: 700;
 
          line-height: 1.25;
 
          margin-top: 10pt;
 
          margin-bottom: 8pt;
 
          padding: 0;
        }
 
        .question-note {
 
          font-size: 11pt;
 
          font-style: italic;
 
          color: #666666;
 
          line-height: 1.25;
 
          margin-top: 0;
 
          margin-bottom: 6pt;
        }
 
        /* =====================================================
           RICH CONTENT
           ===================================================== */
 
        .rich-content {
 
          font-family:
            "Times New Roman",
            Times,
            serif;
 
          font-size: 11pt;
 
          line-height: 1.25;
 
          color: #222222;
 
          word-wrap: break-word;
 
          overflow-wrap: break-word;
 
          margin-left: 30px;
 
          margin-top: 0;
 
          padding: 0;
        }
 
        .rich-content p {
 
          margin-top: 0;
 
          margin-bottom: 6pt;
 
          padding: 0;
        }
 
        /* =====================================================
           BASE64 IMAGES
           ===================================================== */
 
     .rich-content img {
  width: 180px;
  max-width: 180px;
  height: auto;
  display: block;
  margin: 6pt 0;
}
 
        /* =====================================================
           BULLET / NUMBERED LISTS
           ===================================================== */
 
        .rich-content ul {
 
          margin-top: 3px;
 
          margin-bottom: 6pt;
 
          padding-left: 40px;
        }
 
        .rich-content ol {
 
          margin-top: 3px;
 
          margin-bottom: 6pt;
 
          padding-left: 40px;
        }
 
        .rich-content li {
 
          margin-bottom: 3px;
 
          padding-left: 3px;
        }
 
        .rich-content li ul,
        .rich-content li ol {
 
          padding-left: 30px;
        }
 
        /* =====================================================
           TABLES
           ===================================================== */
 
        .rich-content table {
 
          width: 100%;
 
          border-collapse: collapse;
 
          margin-top: 8px;
 
          margin-bottom: 10px;
        }
 
        .rich-content th,
        .rich-content td {
 
          border: 1px solid #999999;
 
          padding: 5px 7px;
 
          vertical-align: top;
 
          font-size: 10.5pt;
 
          line-height: 1.25;
        }
 
        .rich-content th {
 
          font-weight: 700;
 
          background: #f3f3f3;
        }
 
        .empty-content {
 
          color: #777777;
 
          font-style: italic;
 
          margin: 0;
        }
 
        /* =====================================================
           SUB TOPICS
           ===================================================== */
 
        .sub-topic-section {
 
          margin-left: 30px;
 
          margin-top: 4pt;
 
          margin-bottom: 8pt;
 
          font-family:
            "Times New Roman",
            Times,
            serif;
 
          font-size: 11pt;
 
          line-height: 1.25;
        }
 
        .sub-topic-label {
 
          font-weight: 700;
 
          margin-bottom: 3pt;
        }
 
        .sub-topic-list {
 
          margin-top: 2pt;
 
          margin-bottom: 0;
 
          padding-left: 28px;
        }
 
        .sub-topic-list li {
 
          margin-bottom: 3pt;
 
          padding-left: 3px;
 
          line-height: 1.25;
        }
 /* =====================================================
   TOPIC 1 - SUB TOPIC FEEDBACK
   ===================================================== */

/* =====================================================
   TOPIC 1 - SUB TOPIC FEEDBACK
   ===================================================== */

.topic1-feedback-wrapper {
  margin-top: 8pt;
}

.topic1-subtopic {
  margin-left: 30px;
  margin-bottom: 16pt;
  page-break-inside: avoid;
  break-inside: avoid;
}

.topic1-subtopic-title {
  font-size: 11.5pt;
  font-weight: 700;
  margin-top: 8pt;
  margin-bottom: 6pt;
  line-height: 1.3;
}

.topic1-question {
  margin-left: 18px;
  margin-top: 5pt;
  margin-bottom: 6pt;
}

.topic1-question-title {
  font-size: 11pt;
  font-weight: 700;
  margin-bottom: 2pt;
}

.topic1-content {
  margin-left: 18px;
}

.suggested-action-matrix {
  margin-top: 4pt;
  margin-bottom: 8pt;
}

.action-matrix-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: separate !important;
  border-spacing: 0 !important;
  border-top: 1px solid #000 !important;
  border-left: 1px solid #000 !important;
  font-family: "Times New Roman", Times, serif;
  font-size: 10pt;
}

.action-matrix-table th,
.action-matrix-table td {
  border-right: 1px solid #000 !important;
  border-bottom: 1px solid #000 !important;
  border-top: none !important;
  border-left: none !important;
  padding: 6px 8px;
  vertical-align: top;
  text-align: left;
  line-height: 1.25;
  word-wrap: break-word;
  overflow-wrap: break-word;
  background: #fff;
}

.action-matrix-table th {
  font-weight: 700;
  text-align: center;
  background: #f3f3f3;
}

.action-matrix-table td p { margin: 0; }

.action-matrix-table td ul,
.action-matrix-table td ol {
  margin: 2pt 0;
  padding-left: 16px;
}

.action-matrix-table th:nth-child(1), .action-matrix-table td:nth-child(1) { width: 18%; }
.action-matrix-table th:nth-child(2), .action-matrix-table td:nth-child(2) { width: 25%; }
.action-matrix-table th:nth-child(3), .action-matrix-table td:nth-child(3) { width: 18%; }
.action-matrix-table th:nth-child(4), .action-matrix-table td:nth-child(4) { width: 21%; }
.action-matrix-table th:nth-child(5), .action-matrix-table td:nth-child(5) { width: 18%; }
      </style>
 
      <div class="pdf-document">
 
        <!-- HEADER -->
 
        <div class="pdf-header">
 
          ${logoBase64
          ? `
                <div class="logo-wrapper">
 
                  <img
                    class="logo"
                    src="${logoBase64}"
                    alt="NITI Aayog"
                  />
 
                </div>
              `
          : ""
        }
 
          <div class="main-title">
            Sixth National Conference of Chief Secretaries
          </div>
 
          <div class="sub-title">
            Feedback Note
          </div>
 
        </div>
 
        <!-- SECTION 1 -->
 
        <div class="section-title">
          Section 1: Officer Name and Details
        </div>
 
        <ul class="officer-details">
 
          <li>
            <strong>Name:</strong>
            ${escapeHtml(fname)}
          </li>
 
          <li>
            <strong>Designation:</strong>
            ${escapeHtml(designation)}
          </li>
 
          <li>
            <strong>Batch:</strong>
            ${escapeHtml(batchYear)}
          </li>
 
          <li>
            <strong>Current Service Status:</strong>
            ${escapeHtml(currentServiceStatus)}
          </li>
 
          <li>
            <strong>${escapeHtml(postingLabel)}:</strong>
            ${escapeHtml(postingValue)}
          </li>
 
        </ul>
 
        <!-- SECTION 2 -->
 
        <div class="section-title">
 
          Section 2: Feedback for Sixth National Conference of Chief Secretaries
 
        </div>
 
        <!-- QUESTION 1 -->
 
        <div class="feedback-section">
 
          <div class="question-title">
            1. Name of the Topic
          </div>
 
                <div class="rich-content">
  ${getRichContent(nameOfTopic)}
</div>

${!topic1Feedback?.length
          ? getSubTopicsHtml()
          : ""
        }
 
        </div>


 
<!-- =====================================================
     TOPIC 1
     ===================================================== -->

${Array.isArray(topic1Feedback) &&
          topic1Feedback.length > 0
          ? `
      
      ${getTopic1FeedbackHtml()}

    `
          : `

      <!-- =================================================
           TOPIC 2, 3, 4
           NORMAL FEEDBACK
           ================================================= -->

      <!-- QUESTION 2 -->
      <div class="feedback-section">

        <div class="question-title">
          2. Policy Gaps and Challenges
        </div>

        <div class="rich-content">
          ${getRichContent(pgapsAndChallenges)}
        </div>

      </div>


      <!-- QUESTION 3 -->
      <div class="feedback-section">

        <div class="question-title">
          3. Potential Solutions
        </div>

        <div class="rich-content">
          ${getRichContent(potentialSol)}
        </div>

      </div>


      <!-- QUESTION 4 -->
      <div class="feedback-section">

        <div class="question-title">
          4. Best Practices
        </div>

        <div class="rich-content">
          ${getRichContent(bestPractices)}
        </div>

      </div>


      <!-- QUESTION 5 -->
<!-- QUESTION 5 -->

${
  Number(data?.topicValue) === 2
    ? getSuggestedActionMatrixHtml()
    : hasOtherSuggestions
      ? `
        <div class="feedback-section">

          <div class="question-title">
            5. Other Suggestions
          </div>

          <div class="rich-content">
            ${getRichContent(otherSuggestions)}
          </div>

        </div>
      `
      : ""
}

    `
        }
      </div>
    `;

      // =========================================================
      // PDF CONTAINER
      // =========================================================
container = document.createElement("div");
      container.id = "pdf-render-container";
      container.innerHTML = html;
container.style.position = "fixed";
  container.style.left = "-10000px";
      container.style.top = "0";
container.style.width = "794px";
      container.style.margin = "0";
      container.style.padding = "0";
      container.style.backgroundColor = "#ffffff";

      container.style.display = "block";

      container.style.visibility = "visible";

      container.style.opacity = "1";

      container.style.pointerEvents = "none";

      container.style.overflow = "visible";

      document.body.appendChild(container);

      // =========================================================
      // WAIT FOR RENDER
      // =========================================================

      await new Promise((resolve) => {

        requestAnimationFrame(() => {

          requestAnimationFrame(resolve);

        });

      });

      await new Promise((resolve) =>
        setTimeout(resolve, 500)
      );

      // =========================================================
      // WAIT FOR ALL IMAGES
      // =========================================================

      const images =
        container.querySelectorAll("img");

      console.log(
        "PDF images found:",
        images.length
      );

      await Promise.all(

        Array.from(images).map((img) => {

          return new Promise((resolve) => {

            // Already loaded
            if (
              img.complete &&
              img.naturalWidth > 0
            ) {

              resolve();

              return;
            }

            img.onload = () => {

              resolve();

            };

            img.onerror = () => {

              console.warn(
                "PDF image failed to load:",
                img.src.substring(0, 100)
              );

              resolve();

            };

          });

        })

      );

      // Give browser one more render cycle
      await new Promise((resolve) =>
        setTimeout(resolve, 300)
      );

      // Debug image information
      Array.from(images).forEach(
        (img, index) => {

          console.log(
            `PDF Image ${index + 1}:`,
            {
              src: img.src.substring(0, 80),

              complete:
                img.complete,

              naturalWidth:
                img.naturalWidth,

              naturalHeight:
                img.naturalHeight,
            }
          );

        }
      );

      // =========================================================
      // GET DOCUMENT
      // =========================================================

      const pdfDocument =
        container.querySelector(
          ".pdf-document"
        );

      if (!pdfDocument) {

        throw new Error(
          "PDF document was not created."
        );

      }

      // =========================================================
      // CALCULATE HEIGHT
      // =========================================================

      const contentWidth = 794;

      const contentHeight =
        Math.max(
          pdfDocument.scrollHeight,

          pdfDocument.offsetHeight,

          1123
        );

      container.style.width =
        `${contentWidth}px`;

      container.style.height =
        `${contentHeight}px`;

      pdfDocument.style.width =
        `${contentWidth}px`;

      pdfDocument.style.minHeight =
        `${contentHeight}px`;

      pdfDocument.style.height =
        `${contentHeight}px`;

      console.log(
        "PDF width:",
        contentWidth
      );

      console.log(
        "PDF height:",
        contentHeight
      );

      // =========================================================
      // HTML2CANVAS
      // =========================================================

      const canvasScaleFactor = 2;

      const canvas =
        await html2canvas(
          container,
          {

            scale:
              canvasScaleFactor,

            useCORS:
              true,

            allowTaint:
              false,

            backgroundColor:
              "#ffffff",

            logging:
              false,

            x:
              0,

            y:
              0,

            width:
              contentWidth,

            height:
              contentHeight,

            scrollX:
              0,

            scrollY:
              0,

            windowWidth:
              contentWidth,

            windowHeight:
              contentHeight,

          }
        );

      if (
        !canvas ||
        canvas.width <= 0 ||
        canvas.height <= 0
      ) {

        throw new Error(
          `Invalid canvas: ${canvas?.width} x ${canvas?.height}`
        );

      }

      console.log(
        "Canvas:",
        canvas.width,
        "x",
        canvas.height
      );

      // =========================================================
      // CREATE PDF
      // =========================================================

      const pdf =
        new jsPDF({

          orientation:
            "portrait",

          unit:
            "mm",

          format:
            "a4",

          compress:
            true,

        });

      const pageWidth = 210;

      const pageHeight = 297;

      const imgWidth = pageWidth;

      // =========================================================
      // SAFE BREAK POINTS
      // =========================================================
const getSafeBreakPointsPx = (pdfDocumentEl, scaleFactor) => {
  const rootRect = pdfDocumentEl.getBoundingClientRect();

  const blockSelectors = [
    ".pdf-header",
    ".officer-details li",
    ".feedback-section",
    ".topic1-question",
    ".question-note",
    ".rich-content > *",
    ".rich-content li",
    ".rich-content tr",
    ".action-matrix-table tbody tr",   // rows of the matrix table
    ".suggested-action-matrix",        // end of the whole matrix block
  ].join(", ");

  // NOTE: .section-title and .question-title are intentionally NOT here.
  // A break right after a heading strands it at the bottom of a page.

  const breaks = new Set([0]);

  pdfDocumentEl.querySelectorAll(blockSelectors).forEach((el) => {
    const r = el.getBoundingClientRect();
    const bottom = Math.round((r.bottom - rootRect.top) * scaleFactor);
    if (bottom > 0) breaks.add(bottom);
  });

  breaks.add(Math.round(pdfDocumentEl.scrollHeight * scaleFactor));

  return Array.from(breaks).sort((a, b) => a - b);
};

      const cropCanvas = (
        sourceCanvas,
        sy,
        sh
      ) => {

        const cropped =
          document.createElement(
            "canvas"
          );

        cropped.width =
          sourceCanvas.width;

        cropped.height =
          sh;

        const ctx =
          cropped.getContext(
            "2d"
          );

        ctx.fillStyle =
          "#ffffff";

        ctx.fillRect(
          0,
          0,
          cropped.width,
          cropped.height
        );

        ctx.drawImage(

          sourceCanvas,

          0,
          sy,

          sourceCanvas.width,
          sh,

          0,
          0,

          sourceCanvas.width,
          sh

        );

        return cropped;

      };

      // =========================================================
      // ADD PAGES
      // =========================================================

      const marginMm = 15;

      const mmPerCanvasPx =
        pageWidth /
        canvas.width;

      const breakPoints =
        getSafeBreakPointsPx(
          pdfDocument,
          canvasScaleFactor
        );

      let cursor = 0;

      let pageIndex = 0;

      while (
        cursor <
        canvas.height - 1
      ) {

        const topMarginMm =
          pageIndex === 0
            ? 0
            : marginMm;

        const remainingPx =
          canvas.height -
          cursor;

        const fitsWithoutReservedBottomMargin =
          remainingPx *
          mmPerCanvasPx +
          topMarginMm <=
          pageHeight;

        const bottomMarginMm =
          fitsWithoutReservedBottomMargin
            ? 0
            : marginMm;

        const availableMm =
          pageHeight -
          topMarginMm -
          bottomMarginMm;

        const availablePx =
          availableMm /
          mmPerCanvasPx;

        const limit =
          cursor +
          availablePx;

        let cut =
          breakPoints
            .filter(
              (b) =>
                b > cursor &&
                b <= limit
            )
            .pop();

        if (!cut) {

          cut = Math.min(
            limit,
            canvas.height
          );

        }

        const sliceHeight =
          Math.min(
            cut - cursor,
            canvas.height -
            cursor
          );

        const pageCanvas =
          cropCanvas(
            canvas,
            cursor,
            sliceHeight
          );

        const pageImageData =
          pageCanvas.toDataURL(
            "image/jpeg",
            0.98
          );

        const sliceHeightMm =
          sliceHeight *
          mmPerCanvasPx;

        if (pageIndex > 0) {

          pdf.addPage();

        }

        pdf.addImage(

          pageImageData,

          "JPEG",

          0,

          topMarginMm,

          imgWidth,

          sliceHeightMm,

          undefined,

          "FAST"

        );

        cursor = cut;

        pageIndex += 1;

      }

      console.log(
        "Total pages:",
        pageIndex
      );

      // =========================================================
      // SAVE
      // =========================================================

   const filename = `Sixth National Conference Feedback.pdf`;

      pdf.save(filename);

      console.log(
        "PDF generated successfully:",
        filename
      );

    } catch (error) {

      console.error(
        "PDF generation failed:",
        error
      );

      console.error(
        "PDF generation error stack:",
        error?.stack
      );

      alert(
        "Unable to generate PDF. Please try again."
      );

    } finally {

      // =========================================================
      // CLEANUP
      // =========================================================

      if (
        container &&
        container.parentNode
      ) {

        container.parentNode.removeChild(
          container
        );

      }

      console.log(
        "PDF temporary elements cleaned"
      );

    }

  };



  const [data, setData] = useState([]);
  const Checkdetails = async (mobileOrCfmsId) => {
    try {
      if (!mobileOrCfmsId) {
        showAlertMessage("Please enter CFMS ID / Mobile Number", "warning");
        return;
      }

      const res =
        await KpiService.FeedbackFormTopicsByUser({
          mobileOrCfmsId: mobileOrCfmsId,
        });

      console.log("Checkdetails response:", res);

      if (
        res?.data?.SCODE !== "01" ||
        !Array.isArray(res?.data?.SDESC) ||
        res.data.SDESC.length === 0
      ) {
        showAlertMessage(res?.data?.SDESC || "No feedback details found.", "warning", (() => { formik.setFieldValue("cfmsId", ""); }));
        console.error("No feedback details found.");
        setData([]);
        return;
      }

      // Store all records
      setData(res.data.SDESC);

      console.log(
        "Available topics:",
        res.data.SDESC.map(
          (item) => item.name_of_topic
        )
      );

    } catch (error) {
      console.error(
        "Error fetching feedback details:",
        error
      );

      setData([]);
    }
  };

  const generateSelectedTopicWord = async (
    selectedTopicId
  ) => {
    try {
      if (!selectedTopicId) {
        console.error("Please select a topic.");
        return;
      }

      // Find selected record
      const selectedRecord = data.find(
        (item) =>
          String(item.sno) ===
          String(selectedTopicId)
      );

      if (!selectedRecord) {
        console.error("Selected topic details not found.");
        return;
      }

      console.log(
        "Selected topic:",
        selectedRecord
      );

      // =======================================================
      // MAP API RESPONSE TO WORD DOCUMENT DATA
      // =======================================================

      const documentData = {
        cfmsId: selectedRecord.cfms_id || "",
        fname: selectedRecord.f_name || "",
        designation: selectedRecord.designation || "",
        batchYear: selectedRecord.batch_year || "",
        currentServiceStatus: selectedRecord.current_service_status || "",
        trainingInstitute: selectedRecord.training_institute || "",
        currentPosting: selectedRecord.current_posting || "",
        nameOfTopic: selectedRecord.name_of_topic || "",
        pgapsAndChallenges: selectedRecord.p_gaps_and_challenges || "",
        potentialSol:
          selectedRecord.potential_sol || "",

        bestPractices:
          selectedRecord.best_practices || "",
      };

      console.log(
        "Generating Word:",
        documentData
      );

      // =======================================================
      // GENERATE WORD
      // =======================================================

      await generatePdfDocument(
        documentData
      );

    } catch (error) {
      console.error(
        "Error generating selected topic Word:",
        error
      );
    }
  };

  const handleSendOtp = async () => {
    formik.setTouched({
      cfms_id: true,
      name: true,
      designation: true,
      entry_level: true,
      // current_service_status: true,
      training_institute: true,
      current_posting: true,
      district_id: true,
      dept_id: true,
      // topic_name: true,
      // policy_gaps_challenges: true,
      // potential_solutions: true,
      // best_practices: true,
    });

    const errors = await formik.validateForm();

    console.log("================================");
    console.log("FORM VALUES:", formik.values);
    console.log("VALIDATION ERRORS:", errors);
    console.log("ERROR FIELDS:", Object.keys(errors));
    console.log("CURRENT STATUS:", formik.values.current_service_status);
    console.log("================================");

    if (Object.keys(errors).length > 0) {
      showAlertMessage(
        "Please fill all the required fields correctly.",
        "warning"
      );
      return;
    }
    setShowOtpModal(true);
    setOtpSent(false);
    setOtpVerified(false);
    setMobileNumber("");
    setOtp("");
  };

  const handleGetOtp = async () => {
    const mobile = String(mobileNumber || "")
      .replace(/\D/g, "")
      .slice(0, 10);

    if (!/^[6-9]\d{9}$/.test(mobile)) {
      showAlertMessage("Please enter a valid 10-digit mobile number.", "warning");
      return;
    }

    try {
      const res = await KpiService.sendotpfeedbackform({
        mobileNumber: mobile,
      });

      if (res.data?.SCODE === "01") {
        setOtpSent(true);
        setOtpTimer(60);
        setOtpMessage(res.data?.SDESC || "OTP sent successfully.");
      } else {
        setOtpMessage(res.data?.SDESC || "Unable to send OTP.");
        setOtpSent(false);
      }
    } catch (error) {
      console.error("OTP sending error:", error);

      setOtpMessage("Something went wrong while sending the OTP.");
      setOtpSent(false);
    }
  };




  const handleVerifyOtp = () => {
    if (!otp || otp.length !== 6) {
      setOtpMessage("Please enter a valid 6-digit OTP");
      return;
    }

    const params = {
      mobileNumber: mobileNumber,
      otp: otp,
      snccsFeedbackFormDto: {
        cfmsId: formik.values.cfms_id,
        deptId: formik.values.dept_id,
        districtId: formik.values.district_id || "0",
        designation: formik.values.designation,
        batchYear: formik.values.batch || "0",
        currentServiceStatus:
          formik.values.current_service_status === "1"
            ? "Probationer"
            : formik.values.current_service_status === "2"
              ? "Confirmed"
              : "0",
        trainingInstitute: formik.values.training_institute,
        currentPosting: formik.values.current_posting,
        fname: formik.values.name,
        levelOfEntry: formik.values.entry_level,

      },
    };

    KpiService.verifyotpfeedbackform(params)
      .then((res) => {
        if (res.data?.SCODE === "01") {
          setOtpVerified(true);
          setShowOtpModal(false);
          setOtp("");
          setOtpMessage("");

          showAlertMessage(
            res.data?.SDESC || "OTP verified successfully.",
            "success"
          );

          setCurrentStep(3);
          setFirstentry(true);
          setStep2Completed(true);
          setSaveafterDisable(true);
        } else {
          // Show error inside OTP modal
          setOtpMessage(
            res.data?.SDESC || "Invalid OTP. Please try again."
          );
          setOtpVerified(false);
        }
      })
      .catch((error) => {
        console.error("OTP verification error:", error);

        // Show error inside OTP modal
        setOtpMessage(
          "Something went wrong while verifying the OTP."
        );
        setOtpVerified(false);
      });
  };

  const validateCfmsId = async (cfmsId) => {

    setShowSendOtp(false);
  setSubActive("");
    formik.setFieldValue("name", "");
    formik.setFieldValue("entry_level", "");
    formik.setFieldValue("designation", "");
    formik.setFieldValue("dept_id", "");
    formik.setFieldValue("district_id", "");
    formik.setFieldValue("batch", "");
    formik.setFieldValue("current_service_status", "");
    formik.setFieldValue("training_institute", "");
    formik.setFieldValue("current_posting", "");
    if (!cfmsId || !/^(?:\d{8}|\d{10})$/.test(cfmsId)) {
      formik.setFieldValue("cfms_id", "");

      showAlertMessage(
        "Please enter a valid CFMS ID (8 or 10 digits)",
        "warning"
      );

      return false;
    }

    try {

      Swal.fire({
        title: "Validating CFMS ID Details",
        text: "Please wait...",
        width: "min(200px, 80vw)",
        padding: "8px",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,

        didOpen: () => {
          Swal.showLoading();

          const title = Swal.getTitle();
          const text = Swal.getHtmlContainer();

          if (title) {
            title.style.fontSize = "13px";
            title.style.margin = "3px 0";
          }

          if (text) {
            text.style.fontSize = "10px";
            text.style.margin = "3px 0";
          }
        },
      });


      const topicRes =
        await KpiService.CheckcfmsId({
          cfmsId: cfmsId,
        });

      Swal.close();


      // =====================================================
      // CFMS ID DOES NOT EXIST
      // =====================================================

      if (topicRes.data?.SCODE === "02") {

        formik.setFieldValue(
          "cfms_id",
          ""
        );

        setShowSendOtp(false);

        showAlertMessage(
          "No such CFMS ID exists",
          "warning"
        );

        return false;
      }


      // =====================================================
      // EXISTING / RESPONSE
      // =====================================================

      if (
        topicRes.data?.SCODE === "01"
      ) {
        const records = Array.isArray(topicRes.data?.topicsData) ? topicRes.data.topicsData : [];

        console.log(
          "Existing topic records:",
          records
        );


        // =====================================================
        // LOAD SUGGESTED ACTION MATRIX
        // =====================================================

        const matrixData = Array.isArray(
          topicRes.data?.topicsWiseMatrixData
        )
          ? topicRes.data.topicsWiseMatrixData
          : [];

        const suggestedActionMatrix =
          matrixData.length > 0
            ? matrixData.map((row) => ({
              issue: row.issue || "",
              proposed_action:
                row.proposed_action || "",
              lead_agency:
                row.lead_agency || "",
              supporting_agencies:
                row.supporting_agencies || "",
              expected_output_timeline:
                row.expected_outcome_timeline || "",
            }))
            : [
              {
                issue: "",
                proposed_action: "",
                lead_agency: "",
                supporting_agencies: "",
                expected_output_timeline: "",
              },
            ];

        formik.setFieldValue(
          "suggestedActionMatrix",
          suggestedActionMatrix
        );

        console.log(
          "Existing topic records:",
          records
        );

  console.log(
    "Loaded Suggested Action Matrix:",
    suggestedActionMatrix
  );

        if (records.length > 0) {

          setShowSendOtp(false);

          // Find records where topic is actually available
          const validTopicRecords = records.filter(
            (record) =>
              record?.name_of_topic !== null &&
              record?.name_of_topic !== undefined &&
              record?.name_of_topic !== ""
          );

          // Check specifically whether the FIRST record is the first-entry record
          const firstRecord = records[0];

          if (
            firstRecord?.name_of_topic === null ||
            firstRecord?.name_of_topic === undefined ||
            firstRecord?.name_of_topic === ""
          ) {
            // First entry
            setExistingTopics([]);
            setFirstentry(true);
            setSaveafterDisable(true);
          } else {
            // Existing topic
            const topicsWithMatrix = validTopicRecords.map((topic) => ({
  ...topic,
  suggestedActionMatrix:
    String(topic.name_of_topic) === "2"
      ? suggestedActionMatrix
      : [],
}));

setExistingTopics(topicsWithMatrix);;
            setFirstentry(false);
            setSaveafterDisable(false);
          }

          setStep2Completed(true);
          setSelectingNewTopic(false);
          setViewMode(false);
          setOtpVerified(false);

          setCurrentStep(3);

          const details = records[0];

          const statusValue =
            details.current_service_status === "Probationer"
              ? "1"
              : details.current_service_status === "Confirmed"
                ? "2"
                : "";

          // Officer details
          formik.setFieldValue("name", details.f_name || "");
          formik.setFieldValue("cfms_id", details.cfms_id || cfmsId);
          formik.setFieldValue("dept_id", details.dept_id || "");
          formik.setFieldValue("district_id", details.district_id || "");
          formik.setFieldValue("designation", details.designation || "");
          formik.setFieldValue("batch", details.batch_year || "");
          formik.setFieldValue("current_service_status", statusValue);
          formik.setFieldValue(
            "training_institute",
            details.training_institute || ""
          );
          formik.setFieldValue("current_posting", details.current_posting || "");
          formik.setFieldValue("otp_mobile", details.mobile || "");
          formik.setFieldValue("entry_level", details.level_of_entry || "");

          // Clear feedback fields
          formik.setFieldValue("topic_name", "");
          formik.setFieldValue("sub_topic_name", "");
          formik.setFieldValue("policy_gaps_challenges", "");
          formik.setFieldValue("potential_solutions", "");
          formik.setFieldValue("best_practices", "");
          formik.setFieldValue("other_suggestions", "");

          return true;
        }
        if (records.length === 0) {

          console.log(
            "No topics found - new entry"
          );
          setShowSendOtp(true);
          setExistingTopics([]);
          setFirstentry(true);
          setSelectingNewTopic(false);
          setStep2Completed(false);

          setViewMode(false); setOtpVerified(false);
          return true;
        }
      }


      return false;

    } catch (error) {

      store.dispatch({
        type: "HIDE_SPINNER",
      });



      setShowSendOtp(false);

      return false;
    }
  };


  const [subActive, setSubActive] = useState("");
  const [selectedTopics, setSelectedTopics] = useState([]);



const refreshExistingTopics = async (cfmsId) => {
  try {
    const res = await KpiService.CheckcfmsId({ cfmsId });

    if (res.data?.SCODE === "01") {
      const records = Array.isArray(res.data?.topicsData)
        ? res.data.topicsData
        : [];

      // =====================================================
      // LOAD SUGGESTED ACTION MATRIX
      // =====================================================

      const matrixData = Array.isArray(
        res.data?.topicsWiseMatrixData
      )
        ? res.data.topicsWiseMatrixData
        : [];

      const suggestedActionMatrix =
        matrixData.length > 0
          ? matrixData.map((row) => ({
              issue: row.issue || "",
              proposed_action: row.proposed_action || "",
              lead_agency: row.lead_agency || "",
              supporting_agencies:
                row.supporting_agencies || "",
              expected_output_timeline:
                row.expected_outcome_timeline || "",
            }))
          : [
              {
                issue: "",
                proposed_action: "",
                lead_agency: "",
                supporting_agencies: "",
                expected_output_timeline: "",
              },
            ];

      // =====================================================
      // UPDATE FORMIK MATRIX
      // =====================================================

      formik.setFieldValue(
        "suggestedActionMatrix",
        suggestedActionMatrix
      );

      // =====================================================
      // FILTER VALID TOPICS
      // =====================================================

      const validTopicRecords = records.filter(
        (record) =>
          record?.name_of_topic !== null &&
          record?.name_of_topic !== undefined &&
          record?.name_of_topic !== ""
      );

      // =====================================================
      // ADD MATRIX ONLY TO TOPIC 2
      // =====================================================

      const topicsWithMatrix = validTopicRecords.map((topic) => ({
        ...topic,

        suggestedActionMatrix:
          String(topic.name_of_topic) === "2"
            ? suggestedActionMatrix
            : [],
      }));

      // =====================================================
      // REFRESH EXISTING TOPICS
      // =====================================================

      setExistingTopics(topicsWithMatrix);

      // Reset selected view topic
      setSelectedViewTopic(null);

      console.log(
        "Refreshed Existing Topics:",
        topicsWithMatrix
      );

      console.log(
        "Refreshed Suggested Action Matrix:",
        suggestedActionMatrix
      );
    } else {
      // No valid response
      setExistingTopics([]);
      setSelectedViewTopic(null);
    }
  } catch (error) {
    console.error(
      "Error refreshing topics:",
      error
    );
  }
};

  const [activeTab, setActiveTab] = useState("form");

  const [firstentry, setFirstentry] = useState(false);
  const [existingTopics, setExistingTopics] = useState([]);
  const [selectingNewTopic, setSelectingNewTopic] = useState(false);
  const [viewMode, setViewMode] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedViewTopic, setSelectedViewTopic] = useState(null);
  const [saveafterDisable, setSaveafterDisable] = useState(null);




  const enteredTopicIds = existingTopics.map((item) =>
    String(item.name_of_topic)
  );




  const availableTopics = topics.filter(
    (topic) =>
      !enteredTopicIds.includes(
        String(topic.id)
      )
  );




  const allTopicsSubmitted =
    existingTopics?.length === 4 &&
    existingTopics.every((item) => item.is_finalsubmit === true);


  const hasHtmlContent = (v) => {
    if (!v) return false;

    const html = String(v);

    // An image counts as content
    if (/<img\b[^>]*>/i.test(html)) {
      return true;
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    const text = doc.body?.textContent || "";

    return text.trim().length > 0;
  };
  // Reads one saved record and returns { ids, values }
  const buildSubtopicDataFromItem = (item) => {
    // API keys: 11 -> base columns, others -> <base>_sub{id}
    const API_BASE = {
      pgapsandChallengesSub: "p_gaps_and_challenges",
      potentialSolSub: "potential_sol",
      bestPracticesSub: "best_practices",
      otherSuggestionsSub: "other_suggestions",
    };

    const savedIds = parseSubIds(item.name_of_sub_topic);
    const ids = [];
    const values = {};

    SUBTOPIC_IDS.forEach((id) => {
      const apiSuffix = id === "11" ? "" : `_sub${id}`;
      const formSuffix = getSubSuffix(id); // "" for 11, id for others

      let any = false;

      Object.keys(API_BASE).forEach((prefix) => {
        const val = item[`${API_BASE[prefix]}${apiSuffix}`] || "";
        values[`${prefix}${formSuffix}`] = val;
        if (hasHtmlContent(val)) any = true;
      });

      if (any || savedIds.includes(id)) ids.push(id);
    });

    return { ids, values };
  };

  const handleDraft = async (item) => {
    try {
      setViewMode(false);
      setEditMode(true);
      setSelectingNewTopic(false);
      setSaveafterDisable(true);
      setFirstentry(false);

      const topicValue = Number(item.name_of_topic);

      // load subtopic list (needed to render the checkboxes)
      await subTopiclist(topicValue);

      if (topicValue === 1) {
        const { ids, values } = buildSubtopicDataFromItem(item);

        // one update: topic + all subtopic fields (avoids stale values)
        formik.setValues((prev) => ({
          ...prev,
          topic_name: topicValue,
          sub_topic_name: ids[0] || "",
          nameOfSubTopic: ids.join(","),
          // base fields are not used for topic 1
          policy_gaps_challenges: "",
          potential_solutions: "",
          best_practices: "",
          other_suggestions: "",
          ...buildSubtopicInitialValues(), // register all keys with ""
          ...values,                       // fill the saved data
        }));

        setSelectedTopics(ids);      // checkboxes ticked
        setSubActive(ids[0] || "");  // first ticked subtopic opens
      } else {
        // remove subtopic keys, use only base fields
        const subKeys = Object.keys(buildSubtopicInitialValues());

        formik.setValues((prev) => {
          const next = { ...prev };
          subKeys.forEach((k) => delete next[k]);

          return {
            ...next,
            topic_name: topicValue,
            sub_topic_name: "",
            policy_gaps_challenges: item.p_gaps_and_challenges || "",
            potential_solutions: item.potential_sol || "",
            best_practices: item.best_practices || "",
            other_suggestions: item.other_suggestions || "",
          };
        });

        setSelectedTopics([]);
        setSubActive("");
      }

      setCurrentStep(3);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (error) {
      console.error("Error loading draft:", error);
      showAlertMessage("Unable to load draft details.", "error");
    }
  };

  const subTopiclist = async (topicId) => {

    if (!topicId) {

      setSubtopics([]);

      return [];

    }

    try {

      const res =
        await KpiService.snccsSubTopics(
          topicId,
        );



      const data = res.data || []; setSubtopics(data); return data;
    } catch (error) {

      console.error(
        "Subtopic loading error:",
        error
      );

      // setSubtopics([]);

      return [];
    }
  };




const handleView = async (item) => {
  try {
    console.log("Viewing submitted topic:", item);

    setSelectedViewTopic(
      `${item.cfms_id}-${item.name_of_topic}`
    );

    setSaveafterDisable(true);

    setViewMode(true);
    setEditMode(true);
    setSelectingNewTopic(false);
    setFirstentry(false);

    // =====================================================
    // SERVICE STATUS
    // =====================================================

    const statusValue =
      item.current_service_status === "Probationer"
        ? "Probationer"
        : item.current_service_status === "Confirmed"
          ? "Confirmed"
          : "";

    // =====================================================
    // TOPIC
    // =====================================================

    const topicValue = Number(item.name_of_topic);

    // =====================================================
    // LOAD SUBTOPICS
    // =====================================================

    const loadedSubTopics =
      await subTopiclist(topicValue);

    console.log(
      "Loaded Sub Topics:",
      loadedSubTopics
    );

    let selectedSubTopicNames = [];
    let topic1Feedback = [];

    // =====================================================
    // HELPER
    // CHECK IF VALUE REALLY HAS DATA
    // =====================================================

    const hasActualData = (value) => {
      if (
        value === null ||
        value === undefined
      ) {
        return false;
      }

   const cleanHtml = (value) => {
  if (value == null) return "";

  const div = document.createElement("div");
  div.innerHTML = String(value);

  return (div.textContent || div.innerText || "")
    .replace(/&nbsp;/gi, " ")
    .replace(/&#160;/gi, " ")
    .trim();
};
const cleaned = cleanHtml(value);

      return cleaned !== "";
    };

    // =====================================================
    // TOPIC 1
    // =====================================================

    if (topicValue === 1) {

      // ---------------------------------------------------
      // EXISTING SUBTOPIC FORM DATA
      // ---------------------------------------------------

      const {
        ids,
        values
      } = buildSubtopicDataFromItem(item);

   

      // ---------------------------------------------------
      // FORM VALUES
      // ---------------------------------------------------

      formik.setValues((prev) => ({
        ...prev,

        topic_name:
          topicValue,

        sub_topic_name:
          ids.join(","),

        nameOfSubTopic:
          ids.join(","),

        // Topic 1 does NOT use base fields directly
        policy_gaps_challenges: "",
        potential_solutions: "",
        best_practices: "",
        other_suggestions: "",

        ...buildSubtopicInitialValues(),

        ...values,
      }));


      // ===================================================
      // BUILD ONLY SUBTOPICS WHICH HAVE DATA
      // ===================================================

      const subTopicIds = [
        "11",
        "12",
        "13",
        "14",
        "15"
      ];

      topic1Feedback = subTopicIds
        .map((id, index) => {

          // -----------------------------------------------
          // GET SUBTOPIC NAME
          // -----------------------------------------------

          const subTopicName =
            loadedSubTopics?.find(
              (s) =>
                String(s.id) ===
                String(id)
            )?.value ||
            `Sub Topic ${index + 1}`;


          let pgaps = "";
          let potential = "";
          let best = "";
          let other = "";


          // =================================================
          // SUBTOPIC 11
          // NORMAL / BASE FIELDS
          // =================================================

          if (id === "11") {

            pgaps =
              item.p_gaps_and_challenges ||
              "";

            potential =
              item.potential_sol ||
              "";

            best =
              item.best_practices ||
              "";

            other =
              item.other_suggestions ||
              "";
          }


          // =================================================
          // SUBTOPIC 12, 13, 14, 15
          // SUFFIXED FIELDS
          // =================================================

          else {

            pgaps =
              item[
                `p_gaps_and_challenges_sub${id}`
              ] || "";

            potential =
              item[
                `potential_sol_sub${id}`
              ] || "";

            best =
              item[
                `best_practices_sub${id}`
              ] || "";

            other =
              item[
                `other_suggestions_sub${id}`
              ] || "";
          }


          // =================================================
          // CHECK IF THIS SUBTOPIC HAS ANY DATA
          // =================================================

          const hasData =
            hasActualData(pgaps) ||
            hasActualData(potential) ||
            hasActualData(best) ||
            hasActualData(other);


          // -------------------------------------------------
          // NO DATA = REMOVE ENTIRE SUBTOPIC
          // -------------------------------------------------

          if (!hasData) {
            console.log(
              `Skipping empty subtopic ${id}`
            );

            return null;
          }


          // -------------------------------------------------
          // VALID SUBTOPIC
          // -------------------------------------------------

          console.log(
            `Including subtopic ${id}`,
            {
              name: subTopicName,
              pgaps,
              potential,
              best,
              other
            }
          );

          return {
            id: id,

            name:
              subTopicName,

            pgapsAndChallenges:
              pgaps,

            potentialSol:
              potential,

            bestPractices:
              best,

            otherSuggestions:
              other,
          };
        })
        .filter(Boolean);


      // =====================================================
      // ONLY VALID SUBTOPICS
      // =====================================================

      const validTopic1Ids =
        topic1Feedback.map(
          (sub) =>
            String(sub.id)
        );


      selectedSubTopicNames =
        topic1Feedback.map(
          (sub) =>
            sub.name
        );


      // =====================================================
      // SET SELECTED TOPICS
      // =====================================================

      setSelectedTopics(
        validTopic1Ids
      );

      setSubActive(
        validTopic1Ids[0] || ""
      );


      console.log(
        "================================"
      );

      console.log(
        "FINAL TOPIC 1 FEEDBACK:"
      );

      console.log(
        topic1Feedback
      );

      console.log(
        "VALID TOPIC 1 IDS:"
      );

      console.log(
        validTopic1Ids
      );

      console.log(
        "VALID TOPIC 1 NAMES:"
      );

      console.log(
        selectedSubTopicNames
      );

      console.log(
        "================================"
      );

    }

    // =====================================================
    // TOPIC 2, 3, 4
    // =====================================================

    else {

      // ---------------------------------------------------
      // REMOVE ALL TOPIC 1 SUBTOPIC VALUES
      // ---------------------------------------------------

      const subKeys = Object.keys(
        buildSubtopicInitialValues()
      );

      formik.setValues((prev) => {

        const next = {
          ...prev
        };

        subKeys.forEach(
          (key) => {
            delete next[key];
          }
        );

        return {
          ...next,

          topic_name:
            topicValue,

          sub_topic_name:
            "",

          nameOfSubTopic:
            "",

          // -----------------------------------------------
          // NORMAL TOPIC FIELDS
          // -----------------------------------------------

          policy_gaps_challenges:
            item.p_gaps_and_challenges ||
            "",

          potential_solutions:
            item.potential_sol ||
            "",

          best_practices:
            item.best_practices ||
            "",

          other_suggestions:
            item.other_suggestions ||
            "",
        };
      });


      // ---------------------------------------------------
      // CLEAR SUBTOPIC SELECTION
      // ---------------------------------------------------

      setSelectedTopics([]);

      setSubActive("");
    }


    // =====================================================
    // MOVE TO STEP 3
    // =====================================================

    setCurrentStep(3);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });


    // =====================================================
    // TOPIC NAMES
    // =====================================================

    const topicNames = {

      1:
        "5 Specific Priority Objectives for each State towards attainment of Viksit Bharat @2047",

      2:
        "Mining for Economic Growth and Stronger State Finances",

      3:
        "Technology in Governance",

      4:
        "Accelerating Linear Infrastructure Projects: Good Practices and New Ideas",
    };

// =====================================================
// SUGGESTED ACTION MATRIX
// =====================================================

const getSuggestedActionMatrix = (item) => {

  if (!item) {
    return [];
  }

  // ---------------------------------------------------
  // Get matrix from API
  // ---------------------------------------------------

  let matrix =
    item.suggestedActionMatrix ??
    item.suggested_action_matrix ??
    item.suggested_action_matrix_data ??
    item.suggestedActionMatrixData ??
    [];

  console.log(
    "RAW SUGGESTED ACTION MATRIX:",
    matrix
  );

  console.log(
    "RAW MATRIX TYPE:",
    typeof matrix
  );

  // ---------------------------------------------------
  // If already array
  // ---------------------------------------------------

  if (Array.isArray(matrix)) {
    return matrix;
  }

  // ---------------------------------------------------
  // If API sends JSON string
  // ---------------------------------------------------

  if (typeof matrix === "string") {

    const cleaned = matrix
      .replace(/&nbsp;/gi, " ")
      .trim();

    if (!cleaned) {
      return [];
    }

    try {

      const parsed = JSON.parse(cleaned);

      console.log(
        "PARSED MATRIX:",
        parsed
      );

      if (Array.isArray(parsed)) {
        return parsed;
      }

      // Example:
      // { data: [...] }

      if (
        parsed &&
        typeof parsed === "object" &&
        Array.isArray(parsed.data)
      ) {
        return parsed.data;
      }

      // Example:
      // { rows: [...] }

      if (
        parsed &&
        typeof parsed === "object" &&
        Array.isArray(parsed.rows)
      ) {
        return parsed.rows;
      }

    } catch (error) {

      console.error(
        "Suggested Action Matrix JSON parse error:",
        error
      );

    }

    return [];
  }

  // ---------------------------------------------------
  // If API sends object
  // ---------------------------------------------------

  if (
    matrix &&
    typeof matrix === "object"
  ) {

    if (Array.isArray(matrix.data)) {
      return matrix.data;
    }

    if (Array.isArray(matrix.rows)) {
      return matrix.rows;
    }
  }

  return [];
};


// =====================================================
// CHECK MATRIX CELL DATA
// =====================================================

const hasMatrixCellData = (value) => {

  if (
    value === null ||
    value === undefined
  ) {
    return false;
  }

const cleanHtml = (value) => {
  if (value == null) return "";

  const div = document.createElement("div");
  div.innerHTML = String(value);

  return (div.textContent || div.innerText || "")
    .replace(/&nbsp;/gi, " ")
    .replace(/&#160;/gi, " ")
    .trim();
};
const cleaned = cleanHtml(value);

  return cleaned !== "";
};


// =====================================================
// GET MATRIX
// =====================================================

let validSuggestedActionMatrix = [];

if (topicValue === 2) {

  const matrix =
    getSuggestedActionMatrix(item);

  console.log(
    "MATRIX BEFORE FILTER:",
    matrix
  );

  if (Array.isArray(matrix)) {

    validSuggestedActionMatrix =
      matrix.filter((row) => {

        if (!row) {
          return false;
        }

        return [
          row.issue,
          row.proposed_action,
          row.lead_agency,
          row.supporting_agencies,
          row.expected_output_timeline,
        ].some(hasMatrixCellData);

      });

  }

}

console.log(
  "FINAL MATRIX FOR PDF:",
  validSuggestedActionMatrix
);
    // =====================================================
    // PDF DATA
    // =====================================================

    const documentData = {

      // ---------------------------------------------------
      // OFFICER DETAILS
      // ---------------------------------------------------

      cfmsId:
        item.cfms_id || "",

      fname:
        item.f_name || "",

      designation:
        item.designation || "",

      batchYear:
        item.batch_year || "",

      currentServiceStatus:
        statusValue || "",

      trainingInstitute:
        item.training_institute || "",

      currentPosting:
        item.current_posting || "",


      // ---------------------------------------------------
      // TOPIC
      // ---------------------------------------------------

      topicValue:
        topicValue,

      nameOfTopic:
        topicNames[topicValue] || "",


      // ---------------------------------------------------
      // SUBTOPIC NAMES
      // ONLY VALID SUBTOPICS
      // ---------------------------------------------------

      subTopicNames:
        topicValue === 1
          ? selectedSubTopicNames
          : [],


      // ---------------------------------------------------
      // TOPIC 1 FEEDBACK
      // ONLY VALID SUBTOPICS
      // ---------------------------------------------------

      topic1Feedback:
        topicValue === 1
          ? topic1Feedback
          : [],


      // ---------------------------------------------------
      // NORMAL TOPIC FIELDS
      // USED FOR TOPIC 2, 3, 4
      // ---------------------------------------------------

      pgapsAndChallenges:
        item.p_gaps_and_challenges || "",

      potentialSol:
        item.potential_sol || "",

      bestPractices:
        item.best_practices || "",

      otherSuggestions:
        item.other_suggestions || "",


      // ---------------------------------------------------
      // SUGGESTED ACTION MATRIX
      // TOPIC 2 ONLY
      // ---------------------------------------------------

    suggestedActionMatrix: validSuggestedActionMatrix,
    };


    // =====================================================
    // FINAL PDF DATA LOG
    // =====================================================

    console.log(
      "================================"
    );

    console.log(
      "GENERATING PDF WITH DATA:"
    );

    console.log(
      documentData
    );

    console.log(
      "================================"
    );


    // =====================================================
    // GENERATE PDF
    // =====================================================

    await generatePdfDocument(
      documentData
    );

  } catch (error) {

    console.error(
      "Error loading submitted topic:",
      error
    );

    showAlertMessage(
      "Unable to load submitted topic.",
      "error"
    );
  }
};
 

const downloadManual = () => {
    const link = document.createElement("a");
    link.href = selectedManual.file;
    link.download = selectedManual.title || "manual.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  const SectionHeader = ({ title, icon: Icon }) => (
    <div className="py-1 overflow-hidden mb-2" style={{ width: "100%", height: 46, background: "#f7f9f8", display: "flex", alignItems: "center", boxSizing: "border-box", fontFamily: "Arial, sans-serif" }} >
      <div style={{ width: 38, height: 38, background: "#218c45", borderRadius: "0 11px 11px 0", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, boxShadow: "0 1px 4px rgba(0,0,0,.15)" }} >
        <Icon style={{ color: "#fff", fontSize: 19 }} />
      </div>

      <div className="ms-1" style={{ fontSize: 17, fontWeight: 700, color: "#111", whiteSpace: "nowrap" }} >
        {title}
      </div>

      <div className="flex-grow-1 ms-2 me-2" style={{ height: 2, background: "#c8e2d0" }} />
      <div className="d-flex align-items-center flex-shrink-0 pe-1">
        {["#16863c", "#29934a", "#3da45d", "#55ad6d", "#70bd86"].map(
          (color, i) => (
            <span key={i} style={{ width: 8, height: 8, borderTop: `2px solid ${color}`, borderRight: `2px solid ${color}`, transform: "rotate(45deg)", marginLeft: i ? -4 : 0 }} />
          )
        )}
      </div>
    </div>
  );
  const [step2Completed, setStep2Completed] = useState(false);
  const [subtopicAnswers, setSubtopicAnswers] = useState({});
  const SUB_FIELDS = {
    policy_gaps_challenges: {
      formPrefix: "pgapsandChallengesSub",
      apiBase: "pgapsAndChallenges",     // save payload key for first subtopic
      itemBase: "p_gaps_and_challenges", // key in your "topics by user" response
    },
    potential_solutions: {
      formPrefix: "potentialSolSub",
      apiBase: "potentialSol",
      itemBase: "potential_sol",
    },
    best_practices: {
      formPrefix: "bestPracticesSub",
      apiBase: "bestPractices",
      itemBase: "best_practices",
    },
    other_suggestions: {
      formPrefix: "otherSuggestionsSub",
      apiBase: "otherSuggestions",
      itemBase: "other_suggestions",
    },
  };

  const parseSubIds = (value) => {
    const arr = Array.isArray(value)
      ? value
      : String(value || "").split(",");

    return arr
      .map((x) => String(x).trim())
      .filter(Boolean)
      .sort((a, b) => Number(a) - Number(b)); // same order on save and load
  };

  const loadSubtopicValuesFromItem = (item) => {
    const ids = parseSubIds(item.name_of_sub_topic);

    ids.forEach((id, index) => {
      Object.values(SUB_FIELDS).forEach((d) => {
        const value =
          index === 0
            ? item[d.itemBase]                       // first subtopic -> base columns
            : item[`${d.itemBase}_sub${id}`] ??      // adjust these to your real API keys
            item[`${d.formPrefix}${id}`] ??
            item[`${d.itemBase}${id}`];

        formik.setFieldValue(`${d.formPrefix}${id}`, value || "");
      });
    });

    setSelectedTopics(ids);
    setSubActive(ids[0] || "");
    formik.setFieldValue("nameOfSubTopic", ids.join(","));
    formik.setFieldValue("sub_topic_name", ids[0] || "");

    return ids;
  };



  const updateSubtopicAnswer = (field, value, source) => {
    if (source && source !== "user") return; // ignore programmatic changes
    if (!subActive) return;

    const fieldName = getSubtopicFieldName(field, subActive);
    if (!fieldName) return;

    formik.setFieldValue(fieldName, value);
  };


  const handleToggleSubtopic = (id, isChecked) => {
    if (isChecked) {
      const updated = selectedTopics.includes(id)
        ? selectedTopics
        : [...selectedTopics, id];

      setSelectedTopics(updated);
      formik.setFieldValue("nameOfSubTopic", updated.join(","));

      setSubActive(id);
      formik.setFieldValue("sub_topic_name", id);
      return;
    }

    // UNCHECK: remove it and clear ONLY this subtopic's 4 fields
    const updated = selectedTopics.filter((x) => x !== id);

    setSelectedTopics(updated);
    formik.setFieldValue("nameOfSubTopic", updated.join(","));

    formik.setFieldValue(`pgapsandChallengesSub${id}`, "");
    formik.setFieldValue(`potentialSolSub${id}`, "");
    formik.setFieldValue(`bestPracticesSub${id}`, "");
    formik.setFieldValue(`otherSuggestionsSub${id}`, "");

    if (subActive === id) {
      const nextActive = updated[0] || "";
      setSubActive(nextActive);
      formik.setFieldValue("sub_topic_name", nextActive);
    }
  };
  const getSubtopicFieldName = (field, subtopicId) => {
    const id = String(subtopicId);
    const suffix = id === "11" ? "" : id;

    const fieldMap = {
      policy_gaps_challenges: `pgapsandChallengesSub${suffix}`,
      potential_solutions: `potentialSolSub${suffix}`,
      best_practices: `bestPracticesSub${suffix}`,
      other_suggestions: `otherSuggestionsSub${suffix}`,
    };

    return fieldMap[field];
  };

  const getSubtopicFormikValues = (subtopicId) => {
    const id = String(subtopicId);

    // Subtopic 11 -> prefix only (no "11" at the end)
    const suffix = id === "11" ? "" : id;

    return {
      policy_gaps_challenges:
        formik.values[`pgapsandChallengesSub${suffix}`] || "",

      potential_solutions:
        formik.values[`potentialSolSub${suffix}`] || "",

      best_practices:
        formik.values[`bestPracticesSub${suffix}`] || "",

      other_suggestions:
        formik.values[`otherSuggestionsSub${suffix}`] || "",
    };
  };

  const currentSubtopicAnswers = subActive
    ? getSubtopicFormikValues(subActive)
    : {
      policy_gaps_challenges: "",
      potential_solutions: "",
      best_practices: "",
      other_suggestions: "",
    };


  const activeSubtopicIndex = subtopics?.findIndex((item) => String(item.id) === String(subActive));
  const activeSubtopicColor = ["#239447", "#2878d7", "#8050d9", "#f47b20", "#1498ad",][activeSubtopicIndex >= 0 ? activeSubtopicIndex : 0];


  const clearAllSubtopicFields = () => {
    SUBTOPIC_IDS.forEach((id) => {
      if (id === "11") {
        formik.setFieldValue("pgapsandChallengesSub", "");
        formik.setFieldValue("potentialSolSub", "");
        formik.setFieldValue("bestPracticesSub", "");
        formik.setFieldValue("otherSuggestionsSub", "");
      } else {
        formik.setFieldValue(`pgapsandChallengesSub${id}`, "");
        formik.setFieldValue(`potentialSolSub${id}`, "");
        formik.setFieldValue(`bestPracticesSub${id}`, "");
        formik.setFieldValue(`otherSuggestionsSub${id}`, "");
      }
    });
  };

  return (
    <>
      <HeaderPage />
      <Container fluid style={{ width: "95%", marginTop: "110px" }} >
        <div className='sa-title'>
          <h2>Sixth National Conference of Chief Secretaries   <span> Feedback Note</span></h2>
        </div>
      </Container>


      <Container fluid style={{ width: "95%" }} className="outer-page-content-container feedback-page">
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>

            {activeTab === "form" && (
              <>

                <div className="fb-stepper" role="list" aria-label="Form progress">
                  {STEP_LABELS.map((step, i) => {
                    const stepNumber = i + 1;
                    const isDisabled = stepNumber === 3 && !step2Completed;

                    const state = isDisabled
                      ? "is-disabled"
                      : stepNumber < currentStep
                        ? "is-done"
                        : stepNumber === currentStep
                          ? "is-active"
                          : "";

                    return (
                      <div
                        key={step.label}
                        role="button"
                        tabIndex={isDisabled ? -1 : 0}
                        aria-current={stepNumber === currentStep ? "step" : undefined}
                        aria-disabled={isDisabled}
                        className={`fb-step ${state}`}
                        onClick={() => {
                          setSelectedViewTopic(null);

                          if (isDisabled) return;

                          if (currentStep === 3 && stepNumber === 2) {
                            if (!step2Completed) return;
                            setShowSendOtp(false);
                          }

                          setCurrentStep(stepNumber);

                          window.scrollTo({
                            top: 0,
                            behavior: "smooth",
                          });
                        }}
                        onKeyDown={(e) => {
                          if (isDisabled) return;

                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();

                            if (currentStep === 3 && stepNumber === 2) {
                              if (!step2Completed) return;
                              setShowSendOtp(false);
                            }

                            setCurrentStep(stepNumber);

                            window.scrollTo({
                              top: 0,
                              behavior: "smooth",
                            });
                          }
                        }}
                        style={{
                          cursor: isDisabled ? "not-allowed" : "pointer",
                          pointerEvents: isDisabled ? "none" : "auto",
                        }}
                      >
                        <span className="fb-step-dot">
                          {stepNumber < currentStep ? "✓" : stepNumber}
                        </span>

                        <span className="fb-step-label">
                          <span className="fb-step-icon">{step.icon}</span>
                          {step.label}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </>
            )}

            {currentStep === 1 && (<>
              <Container fluid style={{ marginTop: "50px" }}>
                <Row className="g-2 align-items-stretch">

                  {/* INSTRUCTIONS */}
                  <Col lg={3} md={12} className="d-flex">
                    <div style={{ background: "#fffaf3", border: "1px solid #ead9c2", borderLeft: "3px solid #d97706", borderRadius: 8, padding: 10, width: "100%", }} >
                      <h5 style={{ color: "#b45309", marginBottom: 5, fontSize: "14px", }} > Instructions </h5>

                      {[
                        "CFMS IDs are strictly for authentication. The system only verifies employee existence and does not access any other personal data",
                        "Topic wise details must be submitted in English only. Submissions in other languages will not be considered",
                        "Users shall read the relevant Concept Note before furnishing feedback",
                        "Feedback should be practical, implementable and evidence-based",
                        "Users may submit feedback for one or more theme",
                        "Separate feedback note shall be submitted for each theme",
                      ].map((text, i) => (
                        <div key={i} style={{ display: "flex", gap: 6, padding: "3px 0", fontSize: "10px", lineHeight: "1.25", fontWeight: i === 1 ? 600 : 400, }} >
                          <span style={{ color: "#d97706", fontWeight: 700 }}>✓</span>
                          <span>{text}</span>
                        </div>
                      ))}

                      <div style={{ display: "flex", gap: 6, padding: "3px 0", fontSize: "10px", lineHeight: "1.25", fontWeight: 600, }} >
                        <span style={{ color: "#d97706" }}>✓</span>
                        <span>Suggestions should focus on:</span>
                      </div>

                      {/* Subtopics */}
                      <div style={{ marginLeft: 20, marginBottom: 3, }} >
                        {[
                          "Policy gaps and challenges",
                          "Potential solutions",
                          "Technology interventions",
                          "Administrative reforms",
                          "Best practices",
                        ].map((text, i) => (
                          <div key={i} style={{ display: "flex", gap: 4, padding: "1.5px 0", fontSize: "9px", lineHeight: "1.2", color: "#666", }} >
                            <span style={{ color: "#d97706" }}>•</span>
                            <span>{text}</span>
                          </div>
                        ))}
                      </div>

                      {[
                        "References and hyperlinks may be included wherever necessary",
                        "Images, tables and supporting material may be uploaded as part of the submission",
                        "After final submission, modifications shall not be permitted",
                        "A PDF copy of the submitted Feedback Note shall be available for download",

                      ].map((text, i) => (
                        <div key={i} style={{ display: "flex", gap: 6, padding: "3px 0", fontSize: "10px", lineHeight: "1.25", }} >
                          <span style={{ color: "#d97706", fontWeight: 700, }} > ✓ </span>
                          <span>{text}</span>
                        </div>
                      ))}
                    </div>
                  </Col>

                  {/* BOOKS */}
                  <Col lg={9} md={12} className="d-flex">
                    <Row className="g-2 w-100 align-items-stretch">
                      {manuals.map(([title, file], index) => (
                        <Col xs={6} sm={3} key={file} className="d-flex">
                          <button
                            type="button"
                            onClick={() => {
                              setSelectedManual({ title, file });
                              setPage(1);
                              setNumPages(0);
                            }}
                            style={{
                              width: "100%",
                              cursor: "pointer",
                              textAlign: "center",
                              overflow: "visible",
                            }}
                          >
                            {/* PDF */}
                            <div
                              className="manual-preview-area"
                              style={{
                                width: "100%",
                                height: "320px",
                                overflow: "visible",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "flex-start",
                              }}
                            >
                              <div className="manual-preview-book">
                                {/* NUMBER */}
                                <span
                                  style={{
                                    position: "absolute",
                                    top: -5,
                                    right: -8,
                                    zIndex: 2,
                                    background: "#d97706",
                                    color: "#fff",
                                    borderRadius: "50%",
                                    width: 18,
                                    height: 18,
                                    display: "grid",
                                    placeItems: "center",
                                    fontSize: 9,
                                    fontWeight: 600,
                                  }}
                                >
                                  {index + 1}
                                </span>

                                <BookDocument file={file}>
                                  <Page
                                    pageNumber={1}
                                    width={170}
                                    renderTextLayer={false}
                                    renderAnnotationLayer={false}
                                    devicePixelRatio={2}
                                  />
                                </BookDocument>
                              </div>
                            </div>

                            {/* NAME */}
                            <div
                              style={{
                                fontSize: 11,
                                fontWeight: 600,
                                fontFamily: "Caveat, cursive",
                                color: "#d97706",
                                lineHeight: 1.2,
                                padding: "0 3px",
                              }}
                            >
                              {title}
                            </div>
                          </button>
                        </Col>
                      ))}
                    </Row>
                  </Col>

                </Row>
                {/* ========================================================= */}
                {/*                 FLIPBOOK FULL SCREEN POPUP                */}
                {/* ========================================================= */}
                {selectedManual && (
                  <div
                    style={{
                      position: "fixed",
                      inset: 0,
                      background: "rgba(0,0,0,0.78)",
                      zIndex: 9999,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: 0,
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        background: "#fff",
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      {/* ================= HEADER ================= */}
                      <div
                        className="d-flex justify-content-between align-items-center"
                        style={{
                          padding: "8px 15px",
                          borderBottom: "1px solid #ddd",
                          minHeight: 52,
                          flexShrink: 0,
                          background: "#fff",
                        }}
                      >
                        <div style={{ minWidth: 0 }}>
                          <div
                            style={{
                              fontWeight: 700,
                              fontSize: 16,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {selectedManual.title}
                          </div>

                          <small className="text-muted">
                            Page {page} / {numPages}
                          </small>
                        </div>

                        <div className="d-flex align-items-center gap-1">
                          <Button
                            size="sm"
                            variant="outline-secondary"
                            disabled={page <= 1}
                            onClick={previousPage}
                          >
                            ← Previous
                          </Button>

                          <span
                            style={{
                              fontSize: 13,
                              fontWeight: 600,
                              minWidth: 60,
                              textAlign: "center",
                            }}
                          >
                            {page} / {numPages}
                          </span>

                          <Button
                            size="sm"
                            variant="outline-success"
                            disabled={page >= numPages}
                            onClick={nextPage}
                          >
                            Next →
                          </Button>

                          <Button
                            size="sm"
                            variant="outline-primary"
                            onClick={downloadManual}
                          >
                            <FiDownload />
                          </Button>

                          <Button
                            size="sm"
                            variant="outline-danger"
                            onClick={() => {
                              setSelectedManual(null);
                              setPage(1);
                              setNumPages(0);
                            }}
                          >
                            ✕ Close
                          </Button>
                        </div>
                      </div>

                      {/* ================= PDF AREA ================= */}
                      <div
                        className="manual-pdf-area"
                        style={{
                          flex: 1,
                          background: "#eef1f4",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          overflow: "hidden",
                        }}
                      >
                        <BookDocument
                          file={selectedManual.file}
                          onLoadSuccess={({ numPages }) => {
                            setNumPages(numPages);
                            setPage(1);
                          }}
                        >
                          {numPages > 0 && (
                            <>

                              {/* ================= DESKTOP ================= */}
                              <div className="book-desktop">
                                <HTMLFlipBook
                                  ref={desktopFlipBookRef}
                                  width={520}
                                  height={700}
                                  size="fixed"
                                  showCover={true}
                                  usePortrait={false}
                                  mobileScrollSupport={false}
                                  drawShadow
                                  maxShadowOpacity={0.35}
                                  onFlip={(e) => setPage(e.data + 1)}
                                >
                                  {Array.from({ length: numPages }, (_, i) => (
                                    <div
                                      key={i}
                                      style={{
                                        width: "520px",
                                        height: "700px",
                                        background: "#fff",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        overflow: "hidden",
                                      }}
                                    >
                                      <Page
                                        pageNumber={i + 1}
                                        width={i === 0 ? 490 : 520}
                                        renderTextLayer={false}
                                        renderAnnotationLayer={false}
                                        devicePixelRatio={2}
                                      />
                                    </div>
                                  ))}
                                </HTMLFlipBook>
                              </div>

                              {/* ================= TABLET ================= */}
                              <div className="book-tablet">
                                <HTMLFlipBook
                                  width={380}
                                  ref={tabletFlipBookRef}

                                  height={520}
                                  size="fixed"
                                  showCover={true}
                                  usePortrait={false}
                                  mobileScrollSupport={false}
                                  drawShadow
                                  maxShadowOpacity={0.35}
                                  onFlip={(e) => setPage(e.data + 1)}
                                >
                                  {Array.from({ length: numPages }, (_, i) => (
                                    <div
                                      key={i}
                                      style={{
                                        width: "380px",
                                        height: "520px",
                                        background: "#fff",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        overflow: "hidden",
                                      }}
                                    >
                                      <Page
                                        pageNumber={i + 1}
                                        width={i === 0 ? 360 : 380}
                                        renderTextLayer={false}
                                        renderAnnotationLayer={false}
                                        devicePixelRatio={2}
                                      />
                                    </div>
                                  ))}
                                </HTMLFlipBook>
                              </div>

                              {/* ================= MOBILE ================= */}
                              <div className="book-mobile">
                                <HTMLFlipBook
                                  ref={mobileFlipBookRef}
                                  width={280}
                                  height={390}
                                  size="fixed"
                                  showCover={true}
                                  usePortrait={true}
                                  mobileScrollSupport={true}
                                  drawShadow
                                  maxShadowOpacity={0.35}
                                  onFlip={(e) => setPage(e.data + 1)}
                                >
                                  {Array.from({ length: numPages }, (_, i) => (
                                    <div
                                      key={i}
                                      style={{
                                        width: "280px",
                                        height: "390px",
                                        background: "#fff",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        overflow: "hidden",
                                      }}
                                    >
                                      <Page
                                        pageNumber={i + 1}
                                        width={i === 0 ? 260 : 280}
                                        renderTextLayer={false}
                                        renderAnnotationLayer={false}
                                        devicePixelRatio={2}
                                      />
                                    </div>
                                  ))}
                                </HTMLFlipBook>
                              </div>

                            </>
                          )}
                        </BookDocument>
                      </div>
                    </div>
                  </div>
                )}

                <div className="mt-4 border border-1" style={{ display: "flex", alignItems: "center", gap: 16, padding: 2, overflow: "hidden", }} >
                  {/* IMAGE */}
                  <div style={{ width: "20%", minWidth: 100, display: "flex", justifyContent: "center", }} >
                    <img src="/contact.png" alt="Contact" style={{ width: "100%", maxWidth: 160, height: "auto", objectFit: "contain", }} />
                  </div>

                  {/* DETAILS */}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div className="d-flex align-items-center gap-2 mb-2">
                      <div style={{ width: 30, height: 30, borderRadius: 9, background: "#edf7f3", color: "#176B5B", display: "flex", alignItems: "center", justifyContent: "center", }} >
                        <MdPhone size={15} />
                      </div>

                      <div>
                        <div style={{ fontSize: 18, fontWeight: 700, color: "#174C3C", }} > Contact Us </div>
                        <div style={{ fontSize: 12, color: "#888" }}>
                          We're here to help you
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit,minmax(180px,1fr))",
                        gap: 7,
                      }}
                    >
                      {[
                        ["Sowjanya", "Joint Director Planning Department", "9676157398", "#176B5B", <MdPhone size={11} />],
                        ["Janardhana Rao", "Business Analyst", "9494427160", "#365486", <MdPhone size={11} />],
                        [
                          "Help",
                          "Mail Id",
                          ["swarnaandhra_kpis@apcfss.in", "directorplanning2017@gmail.com"],
                          "#365486",
                          <MdEmail size={11} />,
                        ],
                      ].map(([name, role, contact, color, icon]) => (
                        <div
                          key={name}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                            padding: "8px 10px",
                            borderRadius: 10,
                            background: "#f8faf9",
                            border: "1px solid #edf0ef",
                          }}
                        >
                          {/* INITIALS */}
                          <div
                            style={{
                              width: 32,
                              height: 32,
                              borderRadius: "50%",
                              background: `${color}15`,
                              color,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: 10,
                              fontWeight: 700,
                              flexShrink: 0,
                            }}
                          >
                            {name.split(" ").map((x) => x[0]).join("").slice(0, 2)}
                          </div>

                          {/* CONTACT DETAILS */}
                          <div style={{ minWidth: 0 }}>
                            <div
                              style={{
                                fontSize: 12.5,
                                fontWeight: 700,
                                color: "#444",
                              }}
                            >
                              {name}
                            </div>

                            <div
                              style={{
                                fontSize: 11,
                                color: "#888",
                                marginTop: 1,
                              }}
                            >
                              {role}
                            </div>

                            {Array.isArray(contact) ? (
                              <div
                                style={{
                                  fontSize: 10.5,
                                  color,
                                  marginTop: 2,
                                  lineHeight: 1.5,
                                }}
                              >
                                <div>
                                  {icon} {contact[0]}
                                </div>
                                <div style={{ paddingLeft: 13 }}>
                                  {contact[1]}
                                </div>
                              </div>
                            ) : (
                              <div
                                style={{
                                  fontSize: 11.5,
                                  color,
                                  marginTop: 2,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {icon} {contact}
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>


              </Container>

            </>)}

            {currentStep === 2 && (<>
              <Container fluid style={{ marginTop: "50px" }}>

                <div className="mb-2 mt-2" style={{ background: "#fff", border: "1px solid #e5e7eb", borderLeft: "3px solid green", borderRadius: "12px", overflow: "visible", }} >

                  <SectionHeader title="Section 1: Officer Name and Details" icon={FaListUl} />



                  <div className="card-body">
                    <Row className="g-3">
                      <Col xs={12} sm={12} md={6} lg={3}>
                        <div className="d-flex flex-column">
                          <label className="mb-1 fw-bold">CFMS ID<span className="text-danger">*</span></label>
                          <Field
                            type="text"
                            name="cfms_id"
                            className="form-control"
                            maxLength={10}
                            onKeyPress={(e) => { allowNumbersOnly(e); }}
                            onBlur={() => { validateCfmsId(formik.values.cfms_id); formik.setFieldTouched("cfms_id", true); }}
                          />
                          <ErrorMessage name="cfms_id" component="div" className="text-danger" />
                        </div>
                      </Col>
                      <Col xs={12} sm={12} md={6} lg={3}>
                        <div className="d-flex flex-column">
                          <label className="mb-1 fw-bold">Name <span className="text-danger">*</span></label>
                          <Field
                            type="text"
                            name="name"
                            className="form-control"
                            disabled={step2Completed}
                            onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e); }}
                          />
                          <ErrorMessage name="name" component="div" className="text-danger" />
                        </div>
                      </Col>

                      <Col xs={12} sm={12} md={6} lg={3}>
                        <div className="d-flex flex-column">
                          <label className="mb-1 fw-bold">Designation <span className="text-danger">*</span></label>
                          {/* <Select
                            className="w-100 mb-2"
                            name="designation"
                            isClearable
                            isSearchable
                            getOptionValue={(opt) => opt.id}
                            getOptionLabel={(opt) => opt.value}
                            options={designationlist}
                                                        isDisabled={step2Completed}


                            value={
                              designationlist?.find(
                                (opt) => opt.id === formik.values.designation
                              ) || null
                            }
                            onChange={(selectedOption) => {
                              formik.setFieldValue(
                                "designation",
                                selectedOption ? selectedOption.id : ""
                              );
                            }}
                            onBlur={() => {
                              formik.setFieldTouched("designation", true);
                            }}
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                            }}
                          /> */}

                          <Field
                            type="text"
                            name="designation"
                            className="form-control"
                            disabled={step2Completed}
                            onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e); }}
                          />

                          <ErrorMessage name="designation" component="div" className="text-danger" />
                        </div>
                      </Col>
                      <Col xs={12} sm={12} md={6} lg={3}>
                        <div className="d-flex flex-column">
                          <label className="mb-1 fw-bold">
                            Batch
                          </label>

                          <Select
                            className="w-100"
                            name="batch"
                            isClearable
                            isSearchable
                            placeholder="Select Batch"
                            isDisabled={step2Completed}
                            getOptionValue={(opt) => opt.id}
                            getOptionLabel={(opt) => opt.value}
                            options={batchOptions}
                            value={
                              batchOptions.find(
                                (opt) => opt.id === formik.values.batch
                              ) || null
                            }
                            onChange={(opt) => {
                              const value = opt?.id || "";

                              formik.setFieldValue("batch", value);
                              formik.setFieldTouched("batch", true);
                            }}
                            onBlur={() => {
                              formik.setFieldTouched("batch", true);
                            }}
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                              control: (base) => ({
                                ...base,
                                borderColor:
                                  formik.touched.batch && formik.errors.batch
                                    ? "#dc3545"
                                    : base.borderColor,
                              }),
                            }}
                          />

                          <ErrorMessage
                            name="batch"
                            component="div"
                            className="text-danger small mt-1"
                          />
                        </div>
                      </Col>
                      <Col xs={12} sm={12} md={6} lg={3}>
                        <div className="d-flex flex-column">
                          <label className="mb-1 fw-bold">
                            Current Service Status
                          </label>

                          <Select
                            className="w-100 mb-2"
                            name="current_service_status"
                            isClearable
                            isSearchable
                            getOptionValue={(opt) => opt.id}
                            getOptionLabel={(opt) => opt.value}
                            isDisabled={step2Completed}


                            options={[
                              { id: "1", value: "Probationer" },
                              { id: "2", value: "Confirmed" },
                            ]}
                            value={
                              [
                                { id: "1", value: "Probationer" },
                                { id: "2", value: "Confirmed" },
                              ]?.find(
                                (opt) =>
                                  opt.id === formik.values.current_service_status
                              ) || null
                            }
                            onChange={(opt) => {
                              const value = opt?.id || "";

                              formik.setFieldValue(
                                "current_service_status",
                                value
                              );
                              formik.setFieldValue("training_institute", "");
                              formik.setFieldValue("current_posting", "");
                              formik.setFieldTouched("current_service_status", true);
                            }}
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                            }}
                          />
                          <ErrorMessage name="current_service_status" component="div" className="text-danger" />

                        </div>
                      </Col>
                      {formik.values.current_service_status === "1" && (
                        <Col xs={12} sm={12} md={6} lg={3}>
                          <div className="d-flex flex-column">
                            <label className="mb-1 fw-bold">
                              Training Institute / Academy
                              <small className="text-muted mb-1">
                                {" "}(if currently undergoing institutional training)
                              </small>
                            </label>

                            <Field
                              type="text"
                              name="training_institute"
                              className="form-control"
                              disabled={step2Completed}

                            />
                            <ErrorMessage name="training_institute" component="div" className="text-danger" />

                          </div>
                        </Col>
                      )}

                      {formik.values.current_service_status === "2" && (
                        <Col xs={12} sm={12} md={6} lg={3}>
                          <div className="d-flex flex-column">
                            <label className="mb-1 fw-bold">
                              Current Posting
                            </label>

                            <Field
                              type="text"
                              name="current_posting"
                              className="form-control"
                              disabled={step2Completed}
                            />
                            <ErrorMessage name="current_posting" component="div" className="text-danger" />
                          </div>
                        </Col>
                      )}

                      <Col xs={12} sm={12} md={6} lg={3}>
                        <div className="d-flex flex-column">
                          <label className="mb-1 fw-bold">
                            Level of Entry <span className="text-danger">*</span>
                          </label>

                          <Select
                            className="w-100 mb-2"
                            name="entry_level"
                            isClearable
                            isSearchable
                            getOptionValue={(opt) => opt.id}
                            getOptionLabel={(opt) => opt.value}
                            isDisabled={step2Completed}


                            options={[
                              { id: "1", value: "Secretariat" },
                              { id: "2", value: "State HOD" },
                              { id: "3", value: "District" },
                              { id: "4", value: "Constituency" },
                              { id: "5", value: "Division" },
                              { id: "6", value: "Mandal" },
                              { id: "7", value: "Village" },

                            ]}
                            value={
                              [
                                { id: "1", value: "Secretariat" },
                                { id: "2", value: "State HOD" },
                                { id: "3", value: "District" },
                                { id: "4", value: "Constituency" },
                                { id: "5", value: "Division" },
                                { id: "6", value: "Mandal" },
                                { id: "7", value: "Village" },
                              ]?.find(
                                (opt) =>
                                  opt.id === formik.values.entry_level
                              ) || null
                            }
                            onChange={(opt) => {
                              const value = opt?.id || "";

                              formik.setFieldValue(
                                "entry_level",
                                value
                              );
                              formik.setFieldValue("district", "");

                            }}
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                            }}
                          />
                          <ErrorMessage name="entry_level" component="div" className="text-danger" />

                        </div>
                      </Col>


                      {!["1", "2"].includes(formik.values.entry_level) && (
                        <Col xs={12} sm={12} md={6} lg={3}>
                          <div className="d-flex flex-column">
                            <label htmlFor="district_id" className="mb-1 fw-bold">
                              District <span style={{ color: "red" }}>*</span>
                            </label>

                            <Select
                              className="w-100 mb-2"
                              name="district_id"
                              isClearable
                              isSearchable
                              getOptionValue={(opt) => opt.id}
                              getOptionLabel={(opt) => opt.value}
                              options={distlist}
                              isDisabled={step2Completed}


                              value={
                                distlist?.find(
                                  (opt) => opt.id === formik.values.district_id
                                ) || null
                              }
                              onChange={(selectedOption) => {
                                formik.setFieldValue(
                                  "district_id",
                                  selectedOption ? selectedOption.id : ""
                                );
                              }}
                              onBlur={() => {
                                formik.setFieldTouched("district_id", true);
                              }}
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                              }}
                            />

                            <ErrorMessage name="district_id" component="div" className="text-danger" />
                          </div>
                        </Col>
                      )}

                      <Col xs={12} sm={12} md={6} lg={3}>
                        <div className="d-flex flex-column">
                          <label htmlFor="dept_id" className="mb-1 fw-bold">
                            Department <span style={{ color: "red" }}>*</span>
                          </label>

                          <Select
                            className="w-100 mb-2"
                            name="dept_id"
                            isClearable
                            isSearchable
                            isDisabled={step2Completed}

                            getOptionValue={(opt) => opt.dept_id}
                            getOptionLabel={(opt) => opt.dept_name}
                            options={deptlist}
                            value={
                              deptlist?.find(
                                (opt) => opt.dept_id === formik.values.dept_id
                              ) || null
                            }
                            onChange={(selectedOption) => {
                              formik.setFieldValue(
                                "dept_id",
                                selectedOption ? selectedOption.dept_id : ""
                              );
                            }}
                            onBlur={() => {
                              formik.setFieldTouched("dept_id", true);
                            }}
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999, }), }}
                          />

                          <ErrorMessage name="dept_id" component="div" className="text-danger" />
                        </div>
                      </Col>


                    </Row>
                  </div>

                </div>
                <div className="d-flex justify-content-end">
                  {showSendOtp && !otpVerified && (
                    <Button
                      variant="warning"
                      type="button"
                      size="sm"
                      onClick={handleSendOtp}
                      className="me-2"
                    >
                      <RiSendPlaneFill className="me-1" />
                      Register
                    </Button>
                  )}
                  {/* {!showSendOtp && (
                  <Button
                    variant="warning"
 
                    style={{ backgroundColor: "#754b21", border: "1px solid #754b21", color: "#fff" }}
                    type="button"
                    size="sm"
                    onClick={() => {setCurrentStep(3); setStep2Completed(true);}}
                  >
                    Next
                    <GrLinkNext className='ms-1' />
 
                  </Button>
                 ) } */}

                </div>

              </Container>
            </>)}
            {/* Section 2 */}
            {currentStep === 3 && (
              <>
                <div className="card shadow-sm mb-4">
                  <div className="card-header fw-bold">
                    Section 2: Feedback for Sixth National Conference of Chief Secretaries
                    {/* <Button variant="secondary" size="sm" className="float-end" onClick={() => setCurrentStep(2)}><IoMdArrowBack className="me-1" />Previous</Button> */}
                  </div>

                  <div className="card-body">
                    <Row className="g-4">
                      {existingTopics.length > 0 && (
                        <div className="existing-topics-wrapper shadow-sm p-2" style={{ border: "1px solid #ccc" }}>

                          {/* Header */}
                          <div className="existing-topics-header">

                            <div>
                              <h6 style={{ marginBottom: "15px", fontWeight: "600" }}>
                                Drafted Themes{" "}
                                <span style={{ color: "#6c757d", marginLeft: "8px" }}>
                                  CFMS ID:
                                </span>{" "}
                                <span
                                  style={{
                                    color: "#0f2950",
                                    fontWeight: "700",
                                    backgroundColor: "#eaf2ff",
                                    padding: "4px 10px",
                                    borderRadius: "6px",
                                    marginLeft: "4px",
                                    fontSize: "12px"
                                  }}
                                >
                                  {formik.values.cfms_id || "-"}
                                </span>
                              </h6>
                              <small className="existing-topics-subtitle">
                                Themes already entered for this CFMS ID
                              </small>
                            </div>

                            {/* Select New Topic */}
                            {existingTopics.length > 0 &&
                              availableTopics.length > 0 && (
                                <Button
                                  type="button"
                                  size="sm"
                                  variant="warning"

                                  onClick={() => {
                                    setSelectedViewTopic(null);
                                    setSelectingNewTopic(true);
                                    setViewMode(false);
                                    setSaveafterDisable(true);
                                    setSubActive("");
                                    formik.setFieldValue("topic_name", "");
                                    formik.setFieldValue("sub_topic_name", "");
                                    formik.setFieldValue("policy_gaps_challenges", "");
                                    formik.setFieldValue("potential_solutions", "");
                                    formik.setFieldValue("best_practices", "");
                                    formik.setFieldValue("other_suggestions", "");
                                    clearAllSubtopicFields();
                                    setSubtopics([]);

                                    setCurrentStep(3);

                                    window.scrollTo({
                                      top: 0,
                                      behavior: "smooth",
                                    });
                                  }}
                                >
                                  <LuPlus className="mb-1 me-1" />
                                  Submit New Theme
                                </Button>
                              )}

                          </div>


                          {/* Table */}
                          <div className="existing-topics-table-container">

                            <div className="table-responsive">

                              <table className="existing-topics-table">

                                <thead>
                                  <tr>

                                    <th className="sno-column">
                                      S.No
                                    </th>

                                    <th>
                                      Name of the Topic
                                    </th>

                                    <th className="status-column">
                                      Status
                                    </th>

                                    <th className="action-column">
                                      Action
                                    </th>

                                  </tr>
                                </thead>


                                <tbody>

                                  {existingTopics.map(
                                    (item, index) => (
                                      <tr
                                        key={`${item.cfms_id}-${item.name_of_topic}-${index}`}
                                        className={
                                          selectedViewTopic ===
                                            `${item.cfms_id}-${item.name_of_topic}`
                                            ? "selected-view-row"
                                            : ""
                                        }
                                      >

                                        <td className="text-center"> <span className="serial-number"> {index + 1} </span> </td>


                                        <td className="topic-column">

                                          <div className="topic-content">
                                            <span className="topic-name"> {item.topic_des || "-"} </span>
                                          </div>

                                        </td>
                                        <td className="text-center">
                                          {!item.is_finalsubmit ? (
                                            <span className="topic-status draft-status">
                                              Draft
                                            </span>

                                          ) : (

                                            <span className="topic-status submitted-status">
                                              Submitted
                                            </span>

                                          )}

                                        </td>


                                        {/* Action */}
                                        <td className="text-center">

                                          {!item.is_finalsubmit ? (

                                            <button
                                              type="button"
                                              className="topic-action-btn draft-btn"

                                              onClick={() => {
                                                setSelectedViewTopic(
                                                  `${item.cfms_id}-${item.name_of_topic}`
                                                );
                                                handleDraft(item);
                                              }}
                                            >
                                              Edit
                                            </button>

                                          ) : (

                                            <button
                                              type="button"
                                              className="topic-action-btn view-btn"
                                              onClick={() => {
                                                setSelectedViewTopic(
                                                  `${item.cfms_id}-${item.name_of_topic}`
                                                );
                                                handleView(item);
                                              }}
                                            >
                                              View<FaDownload className="mb-1 ms-1" />
                                            </button>

                                          )}

                                        </td>

                                      </tr>))}

                                </tbody> </table> </div>

                          </div>



                          {allTopicsSubmitted && (
                            <div className="all-topics-completed">
                              ✓ All conference topics have been completed.
                            </div>
                          )}

                        </div>
                      )}
                      {(viewMode || editMode) && selectedViewTopic && (
                        <>
                          <div style={{ marginTop: "15px", marginBottom: "20px" }}>
                            <div
                              style={{
                                fontSize: "16px",
                                fontWeight: "600",
                                color: "#333",
                                marginBottom: "12px",
                              }}
                            >
                              <SectionHeader title="1. Name of the topic" icon={FaLayerGroup} />

                            </div>
                            <div
                              style={{
                                marginLeft: "15px",
                                padding: "10px 15px",
                                background: "#f8f9fa",
                                borderLeft: "4px solid #f0ad4e",
                                borderRadius: "4px",
                                fontSize: "15px",
                                fontWeight: "600",
                                color: "#444",
                              }}
                            >
                              {(topics || []).find(
                                (opt) =>
                                  String(opt.id) === String(formik.values.topic_name)
                              )?.value || ""}
                            </div>
                          </div>
                        </>
                      )}

                      {saveafterDisable && (<>


                        <Col xs={12}>
                          {(firstentry || selectingNewTopic) && (<>

                            <SectionHeader title="1. Name of the topic" icon={FaLayerGroup} />

                            <small className="text-muted mb-2">
                              (Choose from the topics of the conference)
                            </small>
                            <div className="d-flex flex-column">


                              <Select
                                className="w-100 mb-2"
                                name="topic_name"
                                isClearable
                                isSearchable

                                getOptionValue={(opt) => String(opt.id)} getOptionLabel={(opt) => opt.value}

                                options={selectingNewTopic ? availableTopics : topics}
                                value={(selectingNewTopic ? availableTopics : topics)?.find((opt) => String(opt.id) === String(formik.values.topic_name)) || null}

                                //                                 onChange={(selectedOption) => {

                                //                                   const topicId = selectedOption ? selectedOption.id : "";
                                // setSubActive(false);
                                //                                   formik.setFieldValue(
                                //                                     "topic_name",
                                //                                     topicId
                                //                                   );

                                //                                   formik.setFieldValue(
                                //                                     "sub_topic_name",
                                //                                     ""
                                //                                   );

                                //                                   if (String(topicId) === "1") {
                                //                                     subTopiclist(topicId);
                                //                                   } else {
                                //                                     setSubtopics("");
                                //                                   }
                                //                                 }}
                                onChange={(selectedOption) => {
                                  const topicId = selectedOption ? selectedOption.id : "";

                                  setSubActive("");
                                  setSelectedTopics([]);

                                  formik.setFieldValue("topic_name", topicId);
                                  formik.setFieldValue("sub_topic_name", "");

                                  if (String(topicId) === "1") {
                                    subTopiclist(topicId);
                                  } else {
                                    setSubtopics([]);   // was setSubtopics("")
                                  }
                                }}
                                onBlur={() => {
                                  formik.setFieldTouched(
                                    "topic_name",
                                    true
                                  );
                                }}

                                menuPortalTarget={document.body}

                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                }}
                              />

                              <ErrorMessage name="topic_name" component="div" className="text-danger" />

                            </div>
                          </>

                          )}
                        </Col>

                        {String(formik.values.topic_name) === "1" && (<>
                          <SectionHeader title="Specific Priority Area(s)" icon={FaListUl} />
                          <small className="text-muted m-0">
                            (Select one or more priority areas. You can write and submit separate feedback for each area you choose)
                          </small>

                          <div className="border-bottom mb-4">
                            <div className="border-bottom mb-4">
                              <div className="d-flex align-items-center gap-4 flex-wrap">

                                {subtopics?.map((subtopic, index) => {
                                  const topicIcons = [
                                    FaLeaf,
                                    FaUtensils,
                                    FaMicrochip,
                                    FaCity,
                                    FaWater,
                                  ];

                                  const topicColors = [
                                    "#239447",
                                    "#2878d7",
                                    "#8050d9",
                                    "#f47b20",
                                    "#1498ad",
                                  ];

                                  const Icon = topicIcons[index % topicIcons.length];
                                  const iconColor = topicColors[index % topicColors.length];

                                  const id = String(subtopic.id);
                                  const label = subtopic.value;



                                  const checked = selectedTopics.includes(id);
                                  const active = subActive === id;



                                  return (
                                    <button
                                      key={id}
                                      type="button"
                                      onClick={() => {
                                        if (checked) {
                                          setSubActive(id);



                                          formik.setFieldValue(
                                            "sub_topic_name",
                                            id
                                          );
                                        }
                                      }}
                                      className="btn rounded-0"
                                      style={{
                                        position: "relative",

                                        flex: "1 1 0",
                                        minWidth: 0,

                                        height: 78,

                                        padding: "10px 30px 10px 10px",

                                        background: active
                                          ? "#f3f8ff"
                                          : "#fff",

                                        border: active
                                          ? `2px solid ${iconColor}`
                                          : `1px solid ${iconColor}55`,

                                        borderRadius: 6,

                                        overflow: "hidden",

                                        display: "flex",
                                        alignItems: "center",

                                        color: "black",

                                        lineHeight: 1,

                                        opacity: checked ? 1 : 0.65,

                                        transition: "all .2s ease",
                                      }}
                                    >


                                      {/* CHECKBOX */}
                                      {/* <span
                                        style={{
                                          background: active
                                            ? "#7c3aed"
                                            : "#4d7b99",
                                          color: "#fff",
                                          padding: "9px 13px",
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          checked={checked}
                                    
                                          disabled={viewMode}

                                          onChange={(e) => {
                                            e.stopPropagation();
                                            handleToggleSubtopic(id, e.target.checked);
                                          }}
                                          onClick={(e) =>
                                            e.stopPropagation()
                                          }
                                          style={{
                                            width: 12,
                                            height: 12,
                                            accentColor: "#fff",
                                            cursor: "pointer",
                                          }}
                                        />
                                      </span> */}


                                      <span
                                        style={{
                                          width: 46,
                                          height: 46,
                                          minWidth: 46,

                                          borderRadius: "50%",

                                          background: iconColor,

                                          color: "#fff",

                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",

                                          marginRight: 10,

                                          boxShadow: "0 2px 5px rgba(0,0,0,.12)",
                                        }}
                                      >
                                        <Icon size={21} />
                                      </span>

                                      {/* SUBTOPIC NAME */}
                                      <span
                                        style={{
                                          color: "#29466b",
                                          fontWeight: 700,
                                          fontSize: 10,
                                          lineHeight: 1.35,

                                          whiteSpace: "normal",

                                          display: "-webkit-box",
                                          WebkitLineClamp: 3,
                                          WebkitBoxOrient: "vertical",
                                          overflow: "hidden",

                                          textAlign: "left",
                                        }}
                                      >
                                        {label}
                                      </span>




                                      <span
                                        style={{
                                          position: "absolute",
                                          top: 7,
                                          right: 7,

                                          width: 16,
                                          height: 16,

                                          borderRadius: "50%",

                                          border: `2px solid ${checked ? iconColor : "#c7d2df"
                                            }`,

                                          background: checked
                                            ? iconColor
                                            : "#fff",

                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        {checked && (
                                          <span
                                            style={{
                                              color: "#fff",
                                              fontSize: 9,
                                              fontWeight: 900,
                                            }}
                                          >
                                            ✓
                                          </span>
                                        )}
                                        <input
                                          type="checkbox"
                                          checked={checked}

                                          disabled={viewMode}

                                          onChange={(e) => {
                                            e.stopPropagation();
                                            handleToggleSubtopic(id, e.target.checked);
                                          }}
                                          onClick={(e) =>
                                            e.stopPropagation()
                                          }
                                          style={{
                                            position: "absolute",
                                            inset: 0,
                                            opacity: 0,
                                            width: "100%",
                                            height: "100%",
                                            cursor: "pointer",
                                          }}
                                        />
                                      </span>
                                    </button>
                                  );
                                })}


                              </div>
                            </div>
                          </div>
                        </>
                        )}


                        {subActive && (
                          <>
                            {/* =========================================================
        2. POLICY GAPS AND CHALLENGES
    ========================================================= */}
                            <div
                              style={{
                                marginTop: 8,
                                padding: "5px",

                                background: `${activeSubtopicColor}12`,



                                borderRadius: "0 8px 8px 8px",

                                transition: "all .25s ease",
                              }}
                            >

                              <Col xs={12}>
                                <SectionHeader
                                  title="2. Policy Gaps and Challenges"
                                  icon={FaPuzzlePiece}
                                />

                                <small className="text-muted mb-2">
                                  (Current policy challenges, administrative and
                                  implementing challenges with respect to the topic selected)
                                </small>

                                <div className="d-flex flex-column">

                                  <div
                                    onPaste={handlePaste}
                                    className="policy-quill-wrapper"
                                  >
                                    <ReactQuill
                                      theme="snow"
                                      key={`policy_gaps_challenges-${subActive}`}
                                      value={
                                        currentSubtopicAnswers
                                          .policy_gaps_challenges || ""
                                      }

                                      onChange={(value, delta, source) =>
                                        updateSubtopicAnswer("policy_gaps_challenges", value, source)
                                      }

                                      modules={{
                                        toolbar: [
                                          [
                                            "bold",
                                            "italic",
                                            "underline",
                                          ],
                                          [
                                            { list: "ordered" },
                                            { list: "bullet" },
                                          ],
                                          ["image"],
                                        ],
                                      }}

                                      formats={[
                                        "bold",
                                        "italic",
                                        "underline",
                                        "list",
                                        "image",
                                      ]}

                                      className="policy-rich-editor"

                                      readOnly={viewMode}
                                    />
                                  </div>

                                  <ErrorMessage
                                    name="policy_gaps_challenges"
                                    component="div"
                                    className="text-danger"
                                  />

                                </div>
                              </Col>


                              {/* =========================================================
        3. POTENTIAL SOLUTIONS
    ========================================================= */}

                              <Col xs={12}>

                                <SectionHeader
                                  title="3. Potential Solutions"
                                  icon={FaLightbulb}
                                />

                                <small className="text-muted mb-2">
                                  (Can potentially highlight new technology solutions,
                                  scope for convergence with other schemes / programmes,
                                  etc.)
                                </small>

                                <div className="d-flex flex-column">

                                  <ReactQuill
                                    theme="snow"
                                    key={`potential_solutions-${subActive}`}

                                    value={
                                      currentSubtopicAnswers
                                        .potential_solutions || ""
                                    }
                                    onChange={(value, delta, source) =>
                                      updateSubtopicAnswer("potential_solutions", value, source)
                                    }
                                    // onChange={(value) =>
                                    //   updateSubtopicAnswer(
                                    //     "potential_solutions",
                                    //     value
                                    //   )
                                    // }

                                    modules={{
                                      toolbar: [
                                        [
                                          "bold",
                                          "italic",
                                          "underline",
                                        ],
                                        [
                                          { list: "ordered" },
                                          { list: "bullet" },
                                        ],
                                        ["image"],
                                      ],
                                    }}

                                    formats={[
                                      "bold",
                                      "italic",
                                      "underline",
                                      "list",
                                      "image",
                                    ]}

                                    placeholder="Enter potential solution"

                                    className="policy-rich-editor"

                                    readOnly={viewMode}
                                  />

                                  <ErrorMessage
                                    name="potential_solutions"
                                    component="div"
                                    className="text-danger"
                                  />

                                </div>

                              </Col>


                              {/* =========================================================
        4. BEST PRACTICES
    ========================================================= */}

                              <Col xs={12}>

                                <SectionHeader
                                  title="4. Best Practices"
                                  icon={FaAward}
                                />

                                <small className="text-muted mb-2">
                                  (Highlights the practices, which are sustainable,
                                  replicable, scalable, monitorable, etc. Can also
                                  highlight the block / district / State level practices)
                                </small>

                                <div className="d-flex flex-column">

                                  <ReactQuill
                                    theme="snow"
                                    key={`best_practices-${subActive}`}
                                    value={
                                      currentSubtopicAnswers
                                        .best_practices || ""
                                    }

                                    onChange={(value, delta, source) =>
                                      updateSubtopicAnswer(
                                        "best_practices",
                                        value, source
                                      )
                                    }

                                    modules={{
                                      toolbar: [
                                        [
                                          "bold",
                                          "italic",
                                          "underline",
                                        ],
                                        [
                                          { list: "ordered" },
                                          { list: "bullet" },
                                        ],
                                        ["image"],
                                      ],
                                    }}

                                    formats={[
                                      "bold",
                                      "italic",
                                      "underline",
                                      "list",
                                      "image",
                                    ]}

                                    placeholder="Enter best practice"

                                    className="policy-rich-editor"

                                    readOnly={viewMode}
                                  />

                                  <ErrorMessage
                                    name="best_practices"
                                    component="div"
                                    className="text-danger"
                                  />

                                </div>

                              </Col>


                              {/* =========================================================
        5. OTHER SUGGESTIONS
    ========================================================= */}

                              <Col xs={12}>

                                <SectionHeader
                                  title="5. Any other Feedback"
                                  icon={MdOutlineRecommend}
                                />

                                <small className="text-muted mb-2">
                                  (any other suggestions or feedback)
                                </small>

                                <div className="d-flex flex-column">

                                  <ReactQuill
                                    theme="snow"
                                    key={`other_suggestions-${subActive}`}
                                    value={
                                      currentSubtopicAnswers
                                        .other_suggestions || ""
                                    }

                                    onChange={(value, delta, source) =>
                                      updateSubtopicAnswer(
                                        "other_suggestions",
                                        value,
                                        source
                                      )
                                    }

                                    modules={{
                                      toolbar: [
                                        [
                                          "bold",
                                          "italic",
                                          "underline",
                                        ],
                                        [
                                          { list: "ordered" },
                                          { list: "bullet" },
                                        ],
                                        ["image"],
                                      ],
                                    }}

                                    formats={[
                                      "bold",
                                      "italic",
                                      "underline",
                                      "list",
                                      "image",
                                    ]}

                                    placeholder="Enter other suggestions"

                                    className="policy-rich-editor"

                                    readOnly={viewMode}
                                  />

                                  <ErrorMessage
                                    name="other_suggestions"
                                    component="div"
                                    className="text-danger"
                                  />

                                </div>

                              </Col>
                            </div>
                          </>
                        )}
                        {/* {!allTopicsSubmitted && */}
                        {(firstentry || selectingNewTopic || viewMode || editMode) && String(formik.values.topic_name) !== "1" && (
                          <>
                            <Col xs={12}>
                              <SectionHeader title="2. Policy Gaps and Challenges" icon={FaPuzzlePiece} />

                              <small className="text-muted mb-2">
                                (Current policy challenges, administrative and implementing
                                challenges with respect to the topic selected)
                              </small>

                              <div className="d-flex flex-column">


                                <div
                                  onPaste={handlePaste}
                                  className="policy-quill-wrapper"
                                >
                                  <ReactQuill
                                    ref={quillRef}
                                    theme="snow"
                                    value={formik.values.policy_gaps_challenges || ""}
                                    onChange={(value) =>
                                      formik.setFieldValue(
                                        "policy_gaps_challenges",
                                        value
                                      )
                                    }
                                    modules={{
                                      toolbar: [
                                        ["bold", "italic", "underline"],
                                        [{ list: "ordered" }, { list: "bullet" }],
                                        ["image"],
                                      ],
                                    }}
                                    formats={[
                                      "bold",
                                      "italic",
                                      "underline",
                                      "list",
                                      "image",
                                    ]}
                                    className="policy-rich-editor"
                                    readOnly={viewMode}
                                  />
                                </div>
                                {/* <ReactQuill
      theme="snow"
      value={formik.values.policy_gaps_challenges || ""}
      onChange={(value) =>
        formik.setFieldValue("policy_gaps_challenges", value)
      }
      modules={{
        toolbar: [
          ["bold", "italic", "underline"],
          [{ list: "ordered" }, { list: "bullet" }],
          ["image"],
        ],
      }}
      formats={[
        "bold",
        "italic",
        "underline",
        "list",
        "image",
      ]}
      className="policy-rich-editor"
      readOnly={viewMode}

      
    /> */}

                                <ErrorMessage
                                  name="policy_gaps_challenges"
                                  component="div"
                                  className="text-danger"
                                />
                              </div>
                            </Col>



                            {/* 3. Potential Solutions */}
                            <Col xs={12}>
                              <SectionHeader title="3. Potential Solutions" icon={FaLightbulb} />

                              <small className="text-muted mb-2">
                                (Can potentially highlight new technology solutions, scope for
                                convergence with other schemes / programmes, etc.)
                              </small>

                              <div className="d-flex flex-column">



                                <ReactQuill
                                  theme="snow"
                                  value={formik.values.potential_solutions || ""}
                                  onChange={(value) =>
                                    formik.setFieldValue("potential_solutions", value)
                                  }
                                  modules={{
                                    toolbar: [
                                      ["bold", "italic", "underline"],
                                      [{ list: "ordered" }, { list: "bullet" }],
                                      ["image"],
                                    ],
                                  }}
                                  formats={[
                                    "bold",
                                    "italic",
                                    "underline",
                                    "list",
                                    "image",
                                  ]}
                                  placeholder="Enter potential solution"
                                  className="policy-rich-editor"
                                  readOnly={viewMode}

                                />

                                <ErrorMessage
                                  name="potential_solutions"
                                  component="div"
                                  className="text-danger"
                                />
                              </div>
                            </Col>
                            {/* 4. Best Practices */}
                            <Col xs={12}>
                              <SectionHeader title="4. Best Practices" icon={FaAward} />
                              <small className="text-muted mb-2">
                                (Highlights the practices, which are sustainable, replicable,
                                scalable, monitorable, etc. Can also highlight the block /
                                district / State level practices)
                              </small>

                              <div className="d-flex flex-column">




                                <ReactQuill
                                  theme="snow"
                                  value={formik.values.best_practices || ""}
                                  onChange={(value) =>
                                    formik.setFieldValue("best_practices", value)
                                  }
                                  modules={{
                                    toolbar: [
                                      ["bold", "italic", "underline"],
                                      [{ list: "ordered" }, { list: "bullet" }],
                                      ["image"],
                                    ],
                                  }}
                                  formats={[
                                    "bold",
                                    "italic",
                                    "underline",
                                    "list",
                                    "image",
                                  ]}
                                  placeholder="Enter best practice"
                                  className="policy-rich-editor"
                                  readOnly={viewMode}
                                />

                                <ErrorMessage
                                  name="best_practices"
                                  component="div"
                                  className="text-danger"
                                />
                              </div>

                            </Col>
                            {String(formik.values.topic_name) === "2"&&
   <Col xs={12}>
  <SectionHeader
    title="5. Suggested Action Matrix"
    icon={MdOutlineRecommend}
  />

                                <small className="text-muted d-block mb-3">
                                  (Suggested actions to address the identified issues, along with
                                  responsible and supporting agencies and expected timelines.)
                                </small>

                                <div className="d-flex flex-column">
                                  <FieldArray name="suggestedActionMatrix">
                                    {({ push, remove }) => (
                                      <div className="mt-2">
                                        <div className="existing-topics-table-container">

                                          <div className="table-responsive">

                                            <table className="existing-topics-table">
                                              <thead>
                                                <tr>
                                                  <th>Issue</th>
                                                  <th>Proposed Action</th>
                                                  <th>Lead Agency</th>
                                                  <th>Supporting Agencies</th>
                                                  <th>Expected Output / Timeline</th>
                                                  <th style={{ width: "90px" }}>Action</th>
                                                </tr>
                                              </thead>

              <tbody>
                {formik.values.suggestedActionMatrix?.map(
                  (row, index) => (
                    <tr key={index}>
                      <td>
<Field
  as="textarea"
  className="form-control"
  rows={3}
  name={`suggestedActionMatrix.${index}.issue`}
  disabled={viewMode}
/>
                      </td>
                      <td>
                  <Field
  as="textarea"
  className="form-control"
  rows={3}
  name={`suggestedActionMatrix.${index}.proposed_action`}
  disabled={viewMode}
/>
                      </td>

                      <td>
<Field
  as="textarea"
  className="form-control"
  rows={3}
  name={`suggestedActionMatrix.${index}.lead_agency`}
  disabled={viewMode}
/>
                      </td>

                      <td>
<Field
  as="textarea"
  className="form-control"
  rows={3}
  name={`suggestedActionMatrix.${index}.supporting_agencies`}
  disabled={viewMode}
/>
                      </td>

                      <td>
<Field
  as="textarea"
  className="form-control"
  rows={3}
  name={`suggestedActionMatrix.${index}.expected_output_timeline`}
  disabled={viewMode}
/>
</td>
                  <td>
  <div className="d-flex align-items-center justify-content-center gap-2">



{ index === formik.values.suggestedActionMatrix.length - 1 && 
  <button
    type="button"
    className="btn btn-outline-success btn-sm"
    onClick={() => {
      const currentRow =
        formik.values.suggestedActionMatrix[index];

                                                                const hasValue = [
                                                                  currentRow.issue,
                                                                  currentRow.proposed_action,
                                                                  currentRow.lead_agency,
                                                                  currentRow.supporting_agencies,
                                                                  currentRow.expected_output_timeline,
                                                                ].some(
                                                                  (value) => value && value.toString().trim() !== ""
                                                                );

                                                                if (!hasValue) {
                                                                  showAlertMessage(
                                                                    "Please fill at least one field before adding a new row.",
                                                                    "warning"
                                                                  );
                                                                  return;
                                                                }

      push({
        issue: "",
        proposed_action: "",
        lead_agency: "",
        supporting_agencies: "",
        expected_output_timeline: "",
      });
    }}
    title="Add row"
  >
    <FaPlus />
  </button>
}
        {index > 0 && (
      <button
        type="button"
        className="btn btn-outline-danger btn-sm"
        onClick={() => remove(index)}
        title="Remove row"
      >
        <FaTrash />
      </button>
    )}

                                                        </div>
                                                      </td>

                                                    </tr>
                                                  )
                                                )}
                                              </tbody>

                                            </table>
                                          </div>
                                        </div>

                                      </div>
                                    )}
                                  </FieldArray>
                                </div>
                              </Col>}
                            {String(formik.values.topic_name) !== "2" &&
                              <Col xs={12}>
                                <SectionHeader title="5. Other Suggestions" icon={MdOutlineRecommend} />
                                <small className="text-muted mb-2">
                                  (any other suggestions or feedback)
                                </small>

                                <div className="d-flex flex-column">

                                  <ReactQuill
                                    theme="snow"
                                    value={formik.values.other_suggestions || ""}
                                    onChange={(value) =>
                                      formik.setFieldValue("other_suggestions", value)
                                    }
                                    modules={{
                                      toolbar: [
                                        ["bold", "italic", "underline"],
                                        [{ list: "ordered" }, { list: "bullet" }],
                                        ["image"],
                                      ],
                                    }}
                                    formats={[
                                      "bold",
                                      "italic",
                                      "underline",
                                      "list",
                                      "image",
                                    ]}
                                    placeholder="Enter other suggestions"
                                    className="policy-rich-editor"
                                    readOnly={viewMode}
                                  />

                                  <ErrorMessage
                                    name="other_suggestions"
                                    component="div"
                                    className="text-danger"
                                  />
                                </div>
                              </Col>
                            }
                          </>)}



                      </>)}
                    </Row>

                  </div>
                </div>



                {/* <div className="fb-actions"> */}
                <div className="fb-actions-right">

                  <div className="fb-actions-right">
                    {(firstentry || selectingNewTopic || editMode) &&
                      // !isCurrentTopicSubmitted &&
                      !allTopicsSubmitted &&
                      !viewMode &&
                      saveafterDisable && (
                        <>
                          <Button
                            type="submit"
                            variant="secondary"
                            size="sm"
                            onClick={() => setSubmitMode("save")}
                          >
                            Draft/Save
                            <MdOutlineDrafts className="ms-1" />
                          </Button>

                          <Button
                            type="submit"
                            size="sm"
                            variant="success"
                            onClick={() => setSubmitMode("submit")}
                          >
                            Submit
                            <LuSaveAll className="ms-1" />
                          </Button>
                        </>
                      )}

                    {otpVerified && isSaved && savedPayload && (
                      <Button
                        type="button"
                        className="fb-btn print-btn"
                        onClick={() => generatePdfDocument(savedPayload)}
                      >
                        Print / Generate Pdf
                      </Button>
                    )}
                  </div>
                  {otpVerified && isSaved && savedPayload && (
                    <Button
                      type="button"
                      className="fb-btn print-btn"
                      onClick={() => generatePdfDocument(savedPayload)}
                    >
                      Print / Generate Pdf
                    </Button>
                  )}

                </div>
                {/* </div> */}


              </>)}

            <Modal
              className="newmodal"
              fade={false}
              size="md"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={showOtpModal}
              onHide={() => setShowOtpModal(false)}
            >
              <Modal.Header
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Modal.Title
                  className="text-center fw-bold"
                  style={{
                    margin: "0 auto",
                    color: "black",
                    fontFamily: "'Times New Roman', Times, serif",
                  }}
                >
                  OTP Verification
                </Modal.Title>

                <span
                  role="button"
                  tabIndex="0"
                  aria-label="Close"
                  onClick={() => setShowOtpModal(false)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      setShowOtpModal(false);
                    }
                  }}
                  style={{
                    fontSize: "29px",
                    cursor: "pointer",
                    color: "black",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = "red")}
                  onMouseLeave={(e) => (e.currentTarget.style.color = "black")}
                >
                  &#215;
                </span>
              </Modal.Header>

              <Modal.Body className="p-3">

                <div className="mandal-container p-4">

                  {/* MOBILE NUMBER */}
                  <Row>
                    <Col xs={12}>
                      <div className="d-flex flex-column">
                        <label className="mb-1 fw-bold">
                          Mobile Number
                        </label>

                        <Field
                          type="text"
                          name="otp_mobile"
                          className="form-control"
                          maxLength="10"
                          autoComplete="off"
                          placeholder="Enter 10-digit mobile number"
                          value={mobileNumber}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, "");
                            setMobileNumber(value);
                          }}
                        />
                        <ErrorMessage
                          name="otp_mobile"
                          component="div"
                          className="text-danger"
                        />
                      </div>
                    </Col>



                  </Row>
                  {/* GET OTP */}
                  {!otpSent && !isSaved && (
                    <Row className="mt-3">
                      <Col xs={12}>
                        <div
                          style={{ textAlign: "center" }}
                          className="bottom-buttons"
                        >
                          <Button
                            variant=""
                            size="sm"
                            className="save-btn"
                            type="button"
                            onClick={handleGetOtp}
                          >
                            Get OTP
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  )}

                  {/* OTP */}
                  {otpSent && !isSaved && (
                    <>
                      <Row className="mt-3">
                        <Col xs={12}>
                          <div className="d-flex flex-column">
                            <label className="mb-1 fw-bold">
                              Enter OTP
                            </label>

                            <input
                              type="text"
                              className="form-control"
                              maxLength="6"
                              autoComplete="off"
                              placeholder="Enter 6-digit OTP"
                              value={otp}
                              onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, "");
                                setOtp(value);
                              }}
                            />
                          </div>
                        </Col>
                      </Row>

                      <Row className="mt-3">
                        <Col xs={12}>
                          <div
                            style={{ textAlign: "center" }}
                            className="bottom-buttons"
                          >
                            <Button
                              variant=""
                              size="sm"
                              className="save-btn"
                              type="button"
                              onClick={handleVerifyOtp}
                            >
                              Verify OTP
                            </Button>
                          </div>
                        </Col>
                      </Row>
                      {otpMessage && (
                        <div
                          style={{
                            marginTop: "15px",
                            padding: "10px 12px",
                            background: "#fff3cd",
                            border: "1px solid #ffe69c",
                            borderRadius: "6px",
                            color: "#856404",
                            fontSize: "14px",
                            textAlign: "center",
                            fontWeight: "600",
                          }}
                        >
                          {otpMessage}
                        </div>
                      )}
                      {/* TIMER / RESEND */}
                      <Row className="mt-2">
                        <Col xs={12}>
                          <div
                            style={{
                              textAlign: "right",
                              fontSize: "13px",
                            }}
                          >
                            {otpTimer > 0 ? (
                              <span style={{ color: "#666" }}>
                                Resend OTP in{" "}
                                <strong style={{ color: "#198754" }}>
                                  {otpTimer}s
                                </strong>
                              </span>
                            ) : (
                              <button
                                type="button"
                                onClick={handleGetOtp}
                                style={{
                                  border: "none",
                                  background: "none",
                                  padding: 0,
                                  color: "#198754",
                                  fontWeight: "600",
                                  cursor: "pointer",
                                  fontSize: "13px",
                                }}
                              >
                                Resend OTP
                              </button>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </>
                  )}


                </div>

              </Modal.Body>

              <Modal.Footer>
                <button
                  type="button"
                  onClick={() => setShowOtpModal(false)}
                  className="cancel"
                >
                  Close
                </button>
              </Modal.Footer>
            </Modal>
     <Modal
  fade={false}
  className="newmodal"
  aria-labelledby="contained-modal-title-vcenter"
  centered
  show={showSubmitConfirmModal}
  onHide={() => setShowSubmitConfirmModal(false)}
  backdrop="static"
  keyboard={false}
>
  <Modal.Header>
    <Modal.Title></Modal.Title>

    <span
      role="button"
      tabIndex={0}
      onClick={() => setShowSubmitConfirmModal(false)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          setShowSubmitConfirmModal(false);
        }
      }}
      onMouseEnter={(e) => (e.currentTarget.style.color = "red")}
      onMouseLeave={(e) => (e.currentTarget.style.color = "white")}
      style={{
        fontSize: "25px",
        cursor: "pointer",
      }}
      className="me-1"
    >
      &#215;
    </span>
  </Modal.Header>

  <Modal.Body className="p-3 d-flex flex-column justify-content-center align-items-center">
    <div className="text-center">

      <img
        src="images/question.gif"
        style={{
          width: "70px",
          marginBottom: "10px",
        }}
        alt="Warning Icon"
      />

      <p
        className="fw-bold"
        style={{
          fontSize: "15px",
        }}
      >
        All themes can be submitted only once.
        <br />
        Are you sure you want to submit?
      </p>

    </div>
  </Modal.Body>

  <Modal.Footer>
 <button
  type="button"
  className="conform"
  onClick={() => {
    setShowSubmitConfirmModal(false);
 
    if (pendingSubmitAction) {
      pendingSubmitAction();
      setPendingSubmitAction(null);
    }
  }}
>
  Yes, Submit
</button>
 
<button
  type="button"
  className="cancel"
  onClick={() => {
    setShowSubmitConfirmModal(false);
    setPendingSubmitAction(null);
  }}
>
  Cancel
</button>
 

  </Modal.Footer>
</Modal>


            {activeTab === "details" && (
              <div
                style={{
                  background: "#fff",
                  border: "1px solid #e2e8f0",
                  borderRadius: "12px",
                  padding: "24px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
                  marginTop: "10px",
                }}
              >
                {/* Header */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    marginBottom: "22px",
                    paddingBottom: "12px",
                    borderBottom: "1px solid #e9ecef",
                  }}
                >
                  <div
                    style={{
                      width: "5px",
                      height: "26px",
                      backgroundColor: "#f6a623",
                      borderRadius: "4px",
                    }}
                  />

                  <h5
                    style={{
                      margin: 0,
                      fontWeight: "700",
                      color: "#1f2937",
                    }}
                  >
                    Feedback Details
                  </h5>
                </div>

                <Row className="g-3">

                  {/* CFMS / Mobile */}
                  <Col xs={12} md={6} lg={5}>
                    <div className="d-flex flex-column">
                      <label
                        className="mb-2"
                        style={{
                          fontWeight: "600",
                          fontSize: "14px",
                          color: "#1f2937",
                        }}
                      >
                        CFMS ID / Mobile Number
                        <span className="text-danger ms-1">*</span>
                      </label>

                      <Field
                        type="text"
                        name="cfms_mob"
                        className="form-control"
                        maxLength={10}
                        placeholder="Enter CFMS ID or Mobile Number"
                        onKeyPress={(e) => {
                          allowNumbersOnly(e);
                        }}
                        style={{
                          height: "42px",
                          borderRadius: "6px",
                          border: "1px solid #b8c4d6",
                          fontSize: "14px",
                        }}
                      />

                      <ErrorMessage
                        name="cfms_mob"
                        component="div"
                        className="text-danger mt-1"
                        style={{ fontSize: "12px" }}
                      />
                    </div>
                  </Col>

                  {/* Get Details */}
                  <Col xs={12} md="auto" className="d-flex align-items-end">
                    <Button
                      type="button"
                      onClick={() => {
                        Checkdetails(formik.values.cfms_mob);
                      }}
                      style={{
                        height: "42px",
                        minWidth: "125px",
                        backgroundColor: "#f59e0b",
                        border: "none",
                        borderRadius: "6px",
                        color: "#fff",
                        fontWeight: "600",
                        fontSize: "14px",
                        boxShadow: "0 2px 4px rgba(245, 158, 11, 0.25)",
                      }}
                    >
                      Get Details
                    </Button>
                  </Col>


                  {data && data.length > 0 && (
                    <Col xs={12}>
                      <div
                        className="d-flex flex-wrap gap-2"
                        style={{
                          marginTop: "8px",
                        }}
                      >
                        {data.map((item, index) => (
                          <div
                            key={item.sno || index}
                            className="d-flex align-items-center"
                            style={{
                              border: "1px solid #d5dce5",
                              borderRadius: "6px",
                              backgroundColor: "#fff",
                              padding: "8px 10px",
                              minHeight: "44px",
                              maxWidth: "100%",
                            }}
                          >
                            {/* Topic */}
                            <span
                              style={{
                                fontSize: "13px",
                                fontWeight: "600",
                                color: "#1f2937",
                                marginRight: "12px",
                              }}
                            >
                              {item.name_of_topic}
                            </span>

                            {/* Download */}
                            <Button
                              type="button"
                              onClick={() => {
                                generateSelectedTopicWord(item.sno);
                              }}
                              title="Download Word"
                              style={{
                                width: "30px",
                                height: "30px",
                                padding: "0",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: "#22a447",
                                border: "none",
                                borderRadius: "5px",
                                color: "#fff",
                                flexShrink: 0,
                              }}
                            >
                              <FiDownload size={15} />
                            </Button>
                          </div>
                        ))}
                      </div>
                    </Col>
                  )}
                  <ErrorMessage
                    name="selectedTopic"
                    component="div"
                    className="text-danger mt-1"
                    style={{ fontSize: "12px" }}
                  />



                </Row>
              </div>
            )}
          </Form>
        </FormikProvider>


        <AlertModal
          show={showAlert}
          titleText={alertData.titleText}
          alertText={alertData.alertText}
          onClose={closeAlert}
        />
      </Container >

    </>
  );
};



